import { HttpErrorResponse } from '@angular/common/http';

import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
  ViewChildren,
  QueryList,
  ChangeDetectionStrategy,
  inject
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { forkJoin, of, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { InventoryService } from 'projects/service/src/app/modules/home/services/inventory.service';
import { ApiResponse, Companies, gridNames, GridPersistRequests, PartsAvailabilityStatus, PersistenceData, UserRoles } from 'projects/service/src/app/shared/models/app.model';
import { CommonService } from 'projects/service/src/app/shared/services/common.service';
import { IscCostTypes, IscCostTypesList, ModeList, IscSubCostTypeList, SubCostTypes, IscRuleModel, IscEmployeeModel, CostTypes } from '../../models/service-order.model';
import { ExecutionTabService } from '../../services/execution-tab.service';
import { ServiceOrderService } from '../../services/service-order.service';
import { CANNOT_CLAIM_TRANSACTION_MESSAGE, UPLOAD_RECEIPT_MESSAGE } from 'projects/service/src/app/shared/messages';
import { ToolbarClickEventArgs } from '@syncfusion/ej2-angular-richtexteditor';
import { IscService } from 'projects/service/src/app/modules/home/services/isc.service';
import { ActionIconDef, Grid as InavistaGrid, GridActionIconClickEvent, GridColumnInfo, GridConfig, GridHyperlinkClickEvent, GridRowCommitEvent, GridRowEditStartEvent, GridRowProblem } from '@inavista/components/grid';
import { CellEdit, DateTimeEditor, DropdownEditor, NumberEditor, TextEditor } from 'projects/service/src/app/shared/utils/cell-editors';
import { ADD_TRANSACTION_ACTION, buildTransactionsActionIcons, buildTransactionsGridConfig, ISC_TRANSACTIONS_PERSISTENCE_KEY, iscTransactionCommands, TRANSACTION_OPEN_FIELD, transactionEditFields, transactionFields, TRANSACTIONS_URL, TransactionsGridContext } from '../execution-tab/transactions.grid.config';
import { LocalRowsGridApi, provideLocalGridRows } from 'projects/service/src/app/shared/utils/local-rows-grid-api';
import { ADD_ASSIGNMENT_ACTION, ASSIGNMENT_COLUMNS, AssignmentsGridContext, buildAssignmentsActionIcons, buildAssignmentsGridConfig, ISC_ASSIGNMENTS_PERSISTENCE_KEY } from '../execution-tab/assignments.grid.config';
import { MasterItemcodePopupComponent } from 'projects/shared/src/lib/components/master-itemcode-popup/master-itemcode-popup.component';

@Component({
    selector: 'app-isc-execution-tab',
    templateUrl: './isc-execution-tab.component.html',
    styleUrls: ['./isc-execution-tab.component.scss'],
    providers: [
        // The Assignments grid reads this.assignments, not an endpoint.
        ...provideLocalGridRows()
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class IscExecutionTabComponent implements OnInit, OnChanges {

  private destroy$: Subject<null> = new Subject();

  serviceTypes = [];
  @Input() data = null;
  @Input() equipmentInfoData = null;
  @Input() configurationId = null;
  @Input() distanceZone = null;
  @Input() customerCurrency = 'USD';
  @Input() isEditable: boolean;
  @Input() fieldRules: any;
  @Input() assignments = [];
  @Input() assignmentDetails = [];
  @Input() taxRates = [];
  @Input() checkinTime: any = null;
  @Input() costTypes = IscCostTypesList;
  @Input() iscEmployeeDetails: IscEmployeeModel;

  preference: any;
  isOffline: boolean;
  isIsc: boolean;
  isIscManager: boolean;
  ddlFetched: boolean = false;
  showAssignmentsPopup: boolean = false;
  getPriceForItem: boolean = true;
  itemChangedFromAdvanceSearch: boolean = false;
  assignmentsConfig: GridConfig = null;
  assignmentsActionIcons: ActionIconDef[] = [];
  /** A row of the Assignments grid has unsaved changes (the old assignmentsGrid.isEdit). */
  assignmentEditing = false;
  refActivityOptions: { value: any; label: string }[] = [];
  reportedProblemOptions: { value: any; label: string }[] = [];
  solutionOptions: { value: any; label: string }[] = [];
  priorityOptions: { value: any; label: string }[] = [];
  /** When the open row was opened: the earliest Start / End Date of a row with none yet, as the old pickers' min. */
  assignmentEditStartedAt = new Date();
  refActivityEditorShown = true;
  lastClickedAssignment: any = null;
  selectedAssignment = null;
  warranty = '';
  contract = '';
  USER;

  coreItemGroup = ['450SVC'];

  isTabValid: boolean = true;
  showAssignmentDetailsPopup: boolean = false;
  skipBeginEditEvent: boolean = false;
  assignmentDetailGrid = null;
  selectedAssignmentDetail = null;
  /**
   * Set this variable if there is only one assignment and reset to null once reference assignment value is populated.
   * We are using this to populate Reference Activity by default if there is only one assignment in assignmentsGrid
   */
  defaultReferenceActivity = null;

  @ViewChild('assignmentTemplate') assignmentTemplate: any;
  @ViewChild('assignmentsGrid') assignmentsGrid: InavistaGrid;
  @ViewChild('refActivityEditor', { static: true }) refActivityEditor: TemplateRef<unknown>;
  @ViewChild('reportedProblemEditor', { static: true }) reportedProblemEditor: TemplateRef<unknown>;
  @ViewChild('solutionEditor', { static: true }) solutionEditor: TemplateRef<unknown>;
  @ViewChild('priorityEditor', { static: true }) priorityEditor: TemplateRef<unknown>;
  @ViewChild('startDateEditor', { static: true }) startDateEditor: TemplateRef<unknown>;
  @ViewChild('endDateEditor', { static: true }) endDateEditor: TemplateRef<unknown>;
  @ViewChild('transactionsGrid') transactionsGrid: InavistaGrid;
  @ViewChildren('txEditor') txEditorTemplates: QueryList<TemplateRef<unknown>>;
  /** The Transactions grid as the old code knew it (see createTransactionsGridShim). */
  readonly assignmentDetailsGrid: any = this.createTransactionsGridShim();
  transactionsConfig: GridConfig = null;
  transactionsActionIcons: ActionIconDef[] = [];
  /** A transaction row is open for editing (the old assignmentDetailsGrid.isEdit). */
  transactionEditing = false;
  /** The new row Add built (setAssignmentDetailRow); it joins this.assignmentDetails when it is saved. */
  pendingNewTransaction: any = null;
  /** The cells drawn with the column's editor (CellEditorHost), and those the grid edits itself (Comments). */
  txEditFields: string[] = [];
  txBuiltInEditFields: string[] = [];
  /** The editors of the open row, by field (CellEditorHost). */
  readonly txOpenEditors = new Map<string, CellEdit>();
  private txSchema: GridColumnInfo[] = [];
  private txContext: TransactionsGridContext = null;
  lastClickedTransaction: any = null;
  /** The open row and its hidden columns: Syncfusion drew an editor for every column, hidden ones included (in hidden
   *  cells), and read them all on save; the old code relies on those editors, so they are drawn out of sight. */
  txHiddenRow: any = null;
  txHiddenEditFields: string[] = [];
  @ViewChild('cartWithCounter') cartWithCounter;

  @Output() tabUpdated = new EventEmitter();
  @Output() showPartsOrderPopup: EventEmitter<any> = new EventEmitter();

  warehouse: string;

  referenceActivities = [];
  reportedProblems = [];
  solutions = [];
  priorities = [];
  units = [];
  serviceItems = [];
  returnReasons = [];
  descriptionObject: TextEditor;

  assignmentObject: DropdownEditor;

  assignmentDetailReferenceActivityObject: TextEditor;
  assignmentDetailReferenceActivityDescription: any;
  assignmentDetailReferenceActivityCode: any;

  assignmentDetailServiceTypeObject: TextEditor;
  assignmentDetailServiceTypeCode: any;
  assignmentDetailServiceTypDescription: any;

  commentsObject: TextEditor;

  costTypeObject: DropdownEditor;

  subcostTypeObject: DropdownEditor;

  itemGroup: any;
  serviceItemGroup: any;
  rowServiceItemGroup: any;

  itemCodeObject: DropdownEditor;

  selectedRowId: string;
  showItemAdvancedSearchPopup: boolean = false;
  onItemUpdate = new Subject<string>();
  itemsList = [];

  itemDescriptionObject: TextEditor;

  mileageObject: NumberEditor;

  additionalMileageObject: NumberEditor;


  quantityObject: NumberEditor;
  onHandQuantity;

  discountAmountObject: NumberEditor;

  iscDiscountAmountObject: NumberEditor;

  warrantyAmountObject: NumberEditor;

  contractAmountObject: NumberEditor;

  customerPriceValue: any;
  customerPriceObject: NumberEditor;

  iscPriceObject: NumberEditor;

  totalAmount: any = 0;
  totalAmountValue: any;
  totalAmountObject: NumberEditor;

  customerTotalAmount: any = 0;
  customerTotalAmountValue: any;
  customerTotalAmountObject: NumberEditor;

  tempUnit: string = '';
  unitObject: DropdownEditor;
  unitCode: any;

  returnReasonObject: DropdownEditor;

  currencyObject: TextEditor;

  assignmentDetailStartTimeValue: any;
  assignmentDetailStartTimeObject: DateTimeEditor;

  assignmentDetailEndTimeObject: DateTimeEditor;

  taskValue: string;
  taskObject: TextEditor;

  taxAmount: any;
  taxObject: NumberEditor;

  taxPercentObject: NumberEditor;

  laborTypeObject: TextEditor;

  costComponentValue: string;
  costComponentObject: TextEditor;

  transactionWarehouseObject: TextEditor;

  activityId: any;
  assignmentId: any;
  warrantyInfo: any;
  contractInfo: any;

  priceValue: any = 0;
  quantityValue: any = 0;
  discountValue: any = 0;
  startTimeValue: any;
  laborRate: any = 0;
  calloutRate: any = 0;
  modelDescription: any;
  serialNumber: any;

  fromExecutionTab: any;
  showCartCheckoutPopup: boolean = false;


  loadedAssignmentItemDetails: any = [];

  assignmentDetailAction: string = '';
  showLoader: boolean = false;
  assignmentsReadOnly: boolean = false;
  transactionsReadOnly: boolean = false;

  iscRulesForSO: IscRuleModel;
  iscRelatedFields = ['mileage', 'price', 'totalAmount', 'iscDiscountAmount', 'addtMileageCharged'];
  isIscSupervisor: boolean = false;

  partsCatalogPopupData;
  showPartsCatalogPopup: boolean = false;
  customerAddress: any = '';
  cartCount: any;
  itemStatus: any;
  alternateItem: any;
  onsiteAddressForPurchaseOrder: any;
  iscNaDiscountRate: any = 0;

  private readonly assignmentsRows = inject(LocalRowsGridApi);
  private readonly transactionsRows = inject(LocalRowsGridApi);

  constructor(
    public commonService: CommonService,
    private dialog: MatDialog,
    private executionTabService: ExecutionTabService,
    private serviceOrderService: ServiceOrderService,
    private iscService: IscService,
    private inventoryService: InventoryService,
    private eRef: ElementRef
  ) {
    this.USER = this.commonService.USER;
    this.assignmentsReadOnly = this.commonService.roleClaims['SO_Popup_Field_assignments']?.readOnly;
    this.transactionsReadOnly = this.commonService.roleClaims['SO_Popup_Fields_transactions']?.readOnly;
  }

  showMasterItemCodePopup(eqData: any) {
    if (!eqData?.itemCode) return;
    const dialogRef = this.dialog.open(MasterItemcodePopupComponent, {
      panelClass: 'master-itemcode-popup-dialog',
      width: '80%',
      height: '80%',
      data: eqData
    });
    dialogRef.afterClosed().subscribe((result) => { });
  }

  // @HostListener('document:click', ['$event'])
  // onClick(event) {
  // if (this.assignmentsGrid?.isEdit) {
  //     if (!document.getElementById('assignmentsGrid')?.contains(event.target)
  //         && !document.getElementById('assignmentsGridreferenceActivityCode_popup')?.contains(event.target)
  //         && !document.getElementById('assignmentsGridreportedProblem_popup')?.contains(event.target)
  //         && !document.getElementById('assignmentsGridsolutionCode_popup')?.contains(event.target)
  //         && !document.getElementById('assignmentsGridpriority_popup')?.contains(event.target)
  //         && !document.getElementById('assignmentsGridstartDate_datepopup')?.contains(event.target)
  //         && !document.getElementById('assignmentsGridstartDate_timepopup')?.contains(event.target)
  //         && !event.target.classList.contains('e-day')
  //         && !document.getElementById('assignmentsGridendDate_datepopup')?.contains(event.target)
  //         && !document.getElementById('assignmentsGridendDate_timepopup')?.contains(event.target)
  //     ) {
  //         this.assignmentsGrid?.endEdit();
  //     }
  // } else if (this.assignmentDetailsGrid?.isEdit) {
  //     if (!document.getElementById('assignmentDetailsGrid')?.contains(event.target)
  //         && !document.getElementById('assignmentDetailsGridassignmentId_popup')?.contains(event.target)
  //         && !document.getElementById('assignmentDetailsGridcostType_popup')?.contains(event.target)
  //         && !document.getElementById('assignmentDetailsGridsubcostType_popup')?.contains(event.target)
  //         && !document.getElementById('assignmentDetailsGridsubCostType_popup')?.contains(event.target)
  //         && !document.getElementById('assignmentDetailsGriditemCode_popup')?.contains(event.target)
  //         && !document.getElementById('assignmentDetailsGridunit_popup')?.contains(event.target)
  //         && !document.getElementById('assignmentDetailsGridlaborType_popup')?.contains(event.target)
  //         && !document.getElementById('assignmentDetailsGridreturnReasonCode_popup')?.contains(event.target)
  //         && !document.getElementById('assignmentDetailsGridstartDate_datepopup')?.contains(event.target)
  //         && !document.getElementById('assignmentDetailsGridstartDate_timepopup')?.contains(event.target)
  //         && !event.target.classList.contains('e-day')
  //         && !document.getElementById('assignmentDetailsGridendDate_datepopup')?.contains(event.target)
  //         && !document.getElementById('assignmentDetailsGridendDate_timepopup')?.contains(event.target)
  //         && !document.getElementById('config-modal')?.contains(event.target)
  //     ) {
  //         if ( !this.showLoader ) {
  //             this.assignmentDetailsGrid.endEdit();
  //         }
  //     }
  // }
  // }

  @HostListener('document:click', ['$event'])
  // A click elsewhere saves the open row, as before: Transactions through endEdit, Assignments through saveBatch.
  onClick(event) {
    const target = event.target as HTMLElement;
    // A click on something already gone (a list option: picking it closed the list) was not a click elsewhere.
    if (!target?.isConnected) return;
    // Not a click in the Assignments grid, its editors' lists and calendars, or a confirmation.
    if (this.assignmentEditing && !target?.closest?.('.assignments-grid, [class*="inavista"], .swal2-container')) {
      this.assignmentsGrid?.saveBatch();
    }
    const grid = this.assignmentDetailsGrid?.isEdit ? this.assignmentDetailsGrid : null;
    // Not a click in the grid, or in what opens over the open row (the item search, a dialog, a confirmation, a list):
    // the old Syncfusion popups were skipped by their classes below; the new ones are skipped here.
    if (grid?.isEdit && !target?.closest?.('.transactions-grid, app-items-advanced-search, .cdk-overlay-container, .swal2-container, [class*="inavista"]')) {
      const excludedClasses = ['e-ddl', 'e-popup', 'e-lib', 'e-control', 'e-popup-close', 'e-day', 'loader-container'];
      let targetElement = event.target as HTMLElement;
      while (targetElement) {
        if (excludedClasses.some(className => targetElement.classList.contains(className))) {
          event.stopPropagation();
          return;
        }
        targetElement = targetElement.parentElement;
      }
      grid.endEdit();
    }
  }

  ngOnInit(): void {
    this.warehouse = this.data?.technicianWarehouse ?? this.USER.warehouse;
    this.isOffline = this.data?.offlineOrder;
    this.isIsc = this.USER.role === UserRoles.isc;
    this.isIscManager = this.USER.role === UserRoles.iscManager;
    this.isIscSupervisor = this.USER.role === UserRoles.IscSupervisor;
    this.data.warrantyCoverageLines && (this.warrantyInfo = JSON.parse(this.data.warrantyCoverageLines));
    this.data.contractCoverageLines && (this.contractInfo = JSON.parse(this.data.contractCoverageLines));

    this.subscriptions();

    this.serviceOrderService.hasTransaction.next(this.assignmentDetails.filter(x => !x.isDeleted).length > 0);
    this.setLoadedAssignmentItemDetails(this.assignmentDetails);
    this.setPageData();
    this.loadTab();
    this.warranty = localStorage.getItem('warranty') ?? '';
    this.contract = localStorage.getItem('contract') ?? '';
    this.assignmentDetailStartTimeValue = this.checkinTime;
    if (this.USER.company === Companies.conway) {
      this.getItemList();
    }
    this.onItemUpdate
      .pipe(
        debounceTime(200),
        distinctUntilChanged()
      ).subscribe(value => {
        if (this.itemCodeObject) {
          this.itemCodeObject.showPopup();
          this.itemCodeObject.showSpinner();
        }
        this.getItemList({ itemCode: value });
      });
  }

  purchaseOrderCreationSub() {
    this.iscService.setCartCount().pipe(
      takeUntil(this.destroy$)
    ).subscribe({
      next: (purchaseOrderCreated: boolean) => {
        if (purchaseOrderCreated) {
          this.showLoader = true;
          this.iscService.getCartCount().subscribe({
            next: (res: ApiResponse) => {
              if (res.isSuccessful) {
                this.cartCount = res.result.cartCount;
                this.showLoader = false;
              } else {
                this.commonService.showNotification('error', res.message)
                this.showLoader = false;
              }
            },
            error: (err: Error) => {
              this.commonService.showNotification('error', err.message)
              this.showLoader = false;
            }
          });
        }
      },
      error: (err) => {
      }
    })
  }

  configurationChangeSub() {
    this.serviceOrderService.configurationChange.pipe(
      takeUntil(this?.destroy$),
    ).subscribe((res: any) => {
      this.inventoryService.getIscOnsiteAddress(this.data.serviceOrderId).subscribe({
        next: (res: any) => {
          res.result = {
            addressName: res.result.name,
            state: res.result.stateProvince,
            ...res.result
          };
          this.onsiteAddressForPurchaseOrder = res.result;
        },
        error: (err: any) => { }
      })
      this.customerAddress = res.customerAddress;
    });
  }

  nteChangeSub() {
    this.serviceOrderService.nteChange.pipe(
      takeUntil(this?.destroy$),
    ).subscribe((args: any) => {
      if (args.value) {
        this.data.approvedAmount = args.value;
      }
    });
  }

  modelDescriptionChangeSub() {
    this.serviceOrderService.modelDescriptionChange.subscribe(modelDescription => {
      this.modelDescription = modelDescription;
    });
  }

  serialNumberChangeSub() {
    this.serviceOrderService.serialNumberChange.pipe(
      takeUntil(this?.destroy$),
    ).subscribe((args: any) => {
      if (args.itemData && args.itemData.serialNumber) {
        this.serialNumber = args.itemData.serialNumber;
      }
    });
  }

  equipmentInfoChangeSub() {
    this.serviceOrderService.equipmentInfoSubject.pipe(
      takeUntil(this?.destroy$),
    ).subscribe(equipmentInfo => {
      if (equipmentInfo) {
        this.equipmentInfoData = equipmentInfo.data;
        this.warrantyInfo = equipmentInfo.warrantyInfo;
        this.contractInfo = equipmentInfo.contractInfo;
        this.equipmentInfoData.warrantyDescriptionObj = equipmentInfo.warrantyInfo;
        this.equipmentInfoData.serviceContractDescriptionObj = equipmentInfo.contractInfo;
      }
    });
  }

  subscriptions() {
    this.purchaseOrderCreationSub();
    this.configurationChangeSub();
    this.nteChangeSub();
    this.modelDescriptionChangeSub();
    this.serialNumberChangeSub();
    this.equipmentInfoChangeSub();
  }

  setLoadedAssignmentItemDetails(transactions) {
    this.loadedAssignmentItemDetails = transactions.map(x => {
      return {
        itemCode: x.itemCode,
        issuedQty: x.issuedQty
      }
    });
  }

  getItemList(rowData?) {
    const value = rowData?.itemCode ?? '';
    this.showLoader = true;
    let serviceItemGroup = '';
    this.commonService.getItems(value, 30, this.USER.company, serviceItemGroup)
      .subscribe((res: ApiResponse) => {
        if (res && res.result && res.result.length) {
          res.result.map(item => {
            item.value = item.item;
            item.text = `${item.item} | ${item.itemDescription}`;
          });

          const existingItems = [];
          (this.assignmentDetailsGrid?.dataSource as any)?.forEach(transaction => {
            if (transaction.itemCode !== this.itemCodeObject?.value) {
              existingItems.push(transaction.itemCode);
            }
          });
          this.itemsList = res.result.filter(item => !existingItems.includes(item.value));
          if (this.itemCodeObject) {
            this.itemCodeObject.hideSpinner();
            this.itemCodeObject.dataSource = this.itemsList;
          }
          this.showLoader = false;
        } else {
          this.itemsList = [];
          if (this.itemCodeObject) {
            this.itemCodeObject.hideSpinner();
            this.itemCodeObject.dataSource = [];
          }
          this.showLoader = false;
        }
      });
  }

  ngOnChanges(change: SimpleChanges): void {
    if (change && change.isEditable) { // Calls if mode changed
      // Do nothing . . .
      // If we want to do anything other than enable/disable we do that here
    }

    if (change && change.assignments && change.assignments.currentValue) {
      this.assignments = change.assignments.currentValue;
      if (this.assignments && this.assignments.length) {
        this.assignments.map(assignment => {
          assignment.tempId = parseInt(assignment.assignmentId);
        });
      }
      if (!change.assignments.firstChange && this.assignmentsConfig) {
        this.refreshAssignmentsGrid();
      }
    }

    if (change && change.taxRates && change.taxRates.currentValue) {
      this.taxRates = change.taxRates.currentValue;
    }

    if (change && change.distanceZone && change.distanceZone.currentValue) {
      this.distanceZone = change.distanceZone.currentValue;
      this.getCalloutChargeRate();
    }

    if (change && change.configurationId && change.configurationId.currentValue) {
      this.configurationId = change.configurationId.currentValue;
      this.getLaborRate();
    }

    if (change && change.assignmentDetails && change.assignmentDetails.currentValue) {
      this.assignmentDetails = change.assignmentDetails.currentValue;
      if (!change.assignmentDetails.firstChange) {
        this.assignmentDetailGrid.dataSource = change.assignmentDetails.currentValue;
        this.assignmentDetailsGrid.columns[2] = {
          field: 'assignmentId', headerText: 'Reference Activity *', width: 148, filter: { type: 'Excel' }, textAlign: 'Left',
          foreignKeyValue: 'referenceActivityDescription', foreignKeyField: 'tempId', showInColumnChooser: false, dataSource: this.assignments, edit: this.editAssignment()
        };
        this.assignmentDetailsGrid.refreshColumns();
        this.assignmentDetailsGrid.refresh();
      }
    }

    if (change && change.isEditable && change.isEditable.currentValue !== undefined && !change.isEditable.firstChange) {
      this.isEditable = change.isEditable.currentValue;
      // this.calculateAmounts(false);
      this.refreshGrids();
    }
  }

  // The Add buttons can only be used while the order is editable (In Progress). Used for both the button's look and its click handler.
  get isAddAssignmentDisabled(): boolean {
    return !this.isEditable;
  }

  get isAddTransactionDisabled(): boolean {
    return !this.isEditable;
  }

  refreshGrids() {
    this.assignmentsConfig && this.refreshAssignmentsGrid();
    this.assignmentDetailsGrid && this.assignmentDetailsGrid.refresh();
  }

  getLaborRate() {
    this.executionTabService.getLaborSalesRate(this.configurationId)
      .subscribe((response: ApiResponse) => {
        if (response && response.isSuccessful) {
          this.laborRate = response.result;
        }
      });
  }

  getCalloutChargeRate() {
    this.executionTabService.getCallOutCharge(this.distanceZone, 0)
      .subscribe((response: ApiResponse) => {
        if (response && response.isSuccessful && response.result) {
          this.calloutRate = response.result;
        }
      });
  }

  validate() {
    // saveBatch() saves the Assignments row still open (as endEdit did); a row that fails its checks stays open.
    this.assignmentsGrid?.saveBatch();
    this.assignmentDetailsGrid?.endEdit();
    if (this.assignmentEditing || this.assignmentDetailsGrid?.isEdit) {
      this.isTabValid = false;
      return false;
    } else {
      this.isTabValid = true;
      return true;
    }
  }

  setPageData() {
    if (!this.data) {
      this.data = {
        serviceOrderId: null,
        serviceType: null,
        salesAmount: 0,
        discountAmount: 0,
        warrantyCoverage: 0,
        contractCoverage: 0,
        invoiceAmount: 0,
        tax: 0,
        taxable: false,
        totalAmount: 0,
        customerTotalAmount: 0
      }
    } else {
      if (this.assignmentDetails?.length) {
        this.calculateAmounts(true);
      }
    }
  }

  loadTab() {
    this.serviceOrderService.popupLoader.next(true);
    forkJoin([
      this.executionTabService.getServiceTypes(this.USER.company),
      this.executionTabService.getIscReferenceActivities(this.data.customerCode, this.data.offlineOrder),
      this.executionTabService.getReportedProblems(this.USER.company, this.data.serializedItemGroupCode),
      this.executionTabService.getSolutions(this.USER.company, this.data.serializedItemGroupCode),
      this.serviceOrderService.getPriorities(this.USER.company),
      this.executionTabService.getUnits(this.USER.company),
      this.executionTabService.getReturnReasons(this.USER.company),
      of(null), // was the Syncfusion Transactions grid's saved layout; the new grid keeps its own (res[8] stays res[8])
      this.serviceOrderService.getIscRuleForServiceOrder(this.data.serviceOrderId),
      this.iscService.getCartCount(),
      this.iscService.getISCNaRateByCustomer(this.data?.configuration)

    ]).subscribe((res: any) => {
      if (res[8]?.result) {
        this.iscRulesForSO = res[8].result;
      }

      this.serviceTypes = res[0].result;
      this.referenceActivities = res[1].result.map(activity => {
        activity.text = activity.description;
        return activity;
      });
      this.reportedProblems = res[2].result.map(problem => {
        problem.text = problem.description;
        return problem;
      });
      this.solutions = res[3].result;
      this.priorities = res[4].result.map(priority => {
        priority.text = priority.description;
        return priority;
      });

      this.units = res[5].result.map(row => {
        row.text = row.description;
        return row;
      });

      this.returnReasons = res[6].result.map(row => {
        row.text = row.description;
        return row;
      });

      this.cartCount = res[9].result?.cartCount;
      this.iscNaDiscountRate = res[10]?.result?.discountRate || 0;

      this.ddlFetched = true;
      if (this.assignmentDetails?.length) {
        this.calculateAmounts(false);
      }
      this.initGrids();
      // this.data.priority = this.data.priority ? this.data.priority : this.priorities.find( priority => priority.text === 'Normal').value;
      this.serviceOrderService.popupLoader.next(false);
      this.commonService.getUserDefaults(this.data.technicianId ?? this.USER.userId);
    }, (error: HttpErrorResponse) => {
      this.serviceOrderService.popupLoader.next(false);
    });
    // this.executionTabService.getServiceTypes()
    // .subscribe( (res: any) => {
    //     this.serviceTypes = res.result;
    // });
  }

  initGrids() {
    if (this.assignments && this.assignments.length) {
      this.assignments.map((assignment, index) => {
        assignment.tempId = parseInt(assignment.assignmentId);
        assignment.rowId = index + 1;
      });
    }
    if (this.assignmentDetails && this.assignmentDetails.length) {
      this.assignmentDetails.map((detail, index) => {
        detail.tempId = parseInt(detail.assignmentDetailId);
        detail.rowId = index + 1;
      });
    }
    this.initAssignmentsGrid();
    this.initAssignmentDetailsGrid();
    this.setupTransactionsGrid();
  }

  // Assignments on @inavista/components: the rows are this.assignments, served by LocalRowsGridApi (no endpoint).
  initAssignmentsGrid() {
    this.assignmentsRows.columns.set(LocalRowsGridApi.schema(ASSIGNMENT_COLUMNS));
    this.reportedProblemOptions = this.reportedProblems.map(p => ({ value: p.value, label: p.description }));
    this.solutionOptions = this.solutions.map(s => ({ value: s.value, label: s.text }));
    this.priorityOptions = this.priorities.map(p => ({ value: p.value, label: p.text }));
    const ctx: AssignmentsGridContext = {
      persistenceKey: ISC_ASSIGNMENTS_PERSISTENCE_KEY,
      editors: {
        referenceActivityDescription: this.refActivityEditor,
        reportedProblemDescription: this.reportedProblemEditor,
        solutionDescription: this.solutionEditor,
        priorityText: this.priorityEditor,
        startDate: this.startDateEditor,
        endDate: this.endDateEditor,
      },
      editLockReason: row => this.assignmentEditLockReason(row),
      actionLockReason: row => this.assignmentActionLockReason(row),
      addDisabledReason: () => this.isAddAssignmentDisabled ? this.addAssignmentDisabledReason() : null,
    };
    this.assignmentsConfig = buildAssignmentsGridConfig(ctx);
    this.assignmentsActionIcons = buildAssignmentsActionIcons(ctx);
    this.refreshAssignmentsGrid();
  }

  // The rows the grid shows: the assignments not deleted, with the lists' text for each code (the old foreign-key columns).
  refreshAssignmentsGrid() {
    const label = (list: any[], value: any, field: string, fallback: any) =>
      list?.find(item => item.value === value)?.[field] ?? fallback ?? '';
    this.assignmentsRows.rows.set(this.assignments.filter(a => !a.isDeleted).map(a => ({
      ...a,
      referenceActivityDescription: label(this.referenceActivities, a.referenceActivityCode, 'description', a.referenceActivityDescription),
      reportedProblemDescription: label(this.reportedProblems, a.reportedProblem, 'description', a.reportedProblemDescription),
      solutionDescription: label(this.solutions, a.solutionCode, 'text', a.solutionDescription),
      priorityText: label(this.priorities, a.priority, 'text', ''),
    })));
    this.assignmentsGrid?.refresh();
  }

  // Why a row can't be opened for inline editing (the old beginEdit cancels), or null.
  assignmentEditLockReason(row: any): string | null {
    if (!this.isEditable) return 'Assignments can be changed while the order is In Progress.';
    if (this.assignmentsReadOnly) return 'You do not have permission to change assignments.';
    if (this.assignmentDetailsGrid?.isEdit) return 'A transaction is being edited. Save or cancel it first.';
    return null;
  }

  // Why a row's Edit and Delete icons are disabled (the old rowDataBound rule), or null.
  assignmentActionLockReason(row: any): string | null {
    if (this.isEditable && this.data.offlineOrder) return null;
    if (this.isEditable && (!row.assignmentId || !row.activityIdLN || row.activityIdLN !== '10')) return null;
    return this.isEditable ? 'This assignment was sent to LN and can\'t be changed here.' : 'Assignments can be changed while the order is In Progress.';
  }

  addAssignmentDisabledReason(): string {
    return !this.isEditable
      ? 'Assignments can be added while the order is In Progress.'
      : 'A Kingslynn order with a billable assignment can\'t get another assignment.';
  }

  // A double click on a locked row says why, as the old grid's notifications did.
  // A double click on a locked row says why, as the old grid did on beginEdit. The grid has no double-click output,
  // so the row comes from its click and the double click from the wrapper.
  onAssignmentDoubleClick() {
    const row = this.lastClickedAssignment;
    if (!row || !this.assignmentEditLockReason(row)) return;
    if (this.assignmentsReadOnly) this.commonService.showPermissionNotification();
    else if (this.assignmentDetailsGrid?.isEdit) this.commonService.showNotification('warning', 'Transactions grid is in edit mode! ');
  }

  // The row opened for editing: the Reference Activity list leaves out the activities the other assignments use, as before.
  onAssignmentEditStart(row: any) {
    const others = this.assignments
      .filter(a => !a.isDeleted && a.referenceActivityCode !== row.referenceActivityCode)
      .map(a => a.referenceActivityCode);
    const list = this.updateRefActivityDS(others);
    this.refActivityOptions = list.map(ref => ({ value: ref.value, label: ref.description }));
    this.assignmentEditStartedAt = new Date();
  }

  // A picked Reference Activity fills Service Type. When the assignment has transactions the user is asked first,
  // and on yes they are deleted at once, as before.
  onRefActivityPicked(code: any, ctx: any) {
    const item = this.referenceActivities.find(ref => ref.value === code);
    if (!item) return;
    const apply = () => {
      ctx.setValue(item.description);
      ctx.setRawCell('referenceActivityCode', item.value);
      ctx.setRawCell('serviceTypeCode', item.serviceTypeCode);
      ctx.setRawCell('serviceTypeDescription', item.serviceTypeDescription);
      ctx.setRawCell('category', item.category);
    };
    // A new row has no tempId yet, so it has no transactions.
    if (ctx.row?.tempId != null && this.hasTransaction(ctx.row)) {
      this.commonService.showConfirmation('Are you sure? The transactions added for this assignment will be deleted').then(res => {
        if (res.isConfirmed) {
          apply();
          this.deleteAssignmentDetailsByAssignment(ctx.row);
        } else {
          // Put the old value back: the dropdown is drawn again from the row's unchanged code.
          this.refActivityEditorShown = false;
          setTimeout(() => this.refActivityEditorShown = true);
        }
      });
    } else {
      apply();
    }
  }

  onListPicked(list: any[], textField: string, codeColumn: string, value: any, ctx: any) {
    const item = list?.find(i => i.value === value);
    ctx.setValue(item?.[textField] ?? '');
    ctx.setRawCell(codeColumn, value);
  }

  // Enter, the ✓ icon or the popup's Save: the edited values go back into this.assignments (a new row is added).
  onAssignmentCommit(commit: GridRowCommitEvent) {
    const r: any = commit.row;
    const target = commit.isDraft ? this.setAssignmentRow({}) : this.assignments.find(a => a.rowId === r.rowId);
    if (!target) return;
    for (const field of ['referenceActivityCode', 'referenceActivityDescription', 'serviceTypeCode', 'serviceTypeDescription',
      'reportedProblem', 'reportedProblemDescription', 'description', 'solutionCode', 'solutionDescription', 'priority',
      'startDate', 'endDate', 'category']) {
      if (field in r) target[field] = r[field] === '' && (field === 'startDate' || field === 'endDate') ? null : r[field];
    }
    // As before: while Start Date is hidden, an assignment starts at check-in.
    if (this.assignmentsGrid?.captureState().columnVisibility?.['startDate'] !== true) {
      target.startDate = this.checkinTime ? new Date(this.checkinTime) : null;
    }
    if (commit.isDraft) this.assignments.push(target);
    this.assignmentEditing = false;
    this.calculateAmounts(false);
    this.isTabValid = true;
    this.refreshGrids();
  }

  onAssignmentRevert() {
    this.assignmentEditing = false;
  }

  onAssignmentsToolbarAction(event: { key: string }) {
    if (event.key !== ADD_ASSIGNMENT_ACTION || this.isAddAssignmentDisabled) return;
    if (this.assignmentEditing) {
      this.commonService.showNotification('warning', 'There is a row in assignment grid, which is already in edit mode!', 'center', 5000);
    } else if (this.assignmentsReadOnly) {
      this.commonService.showPermissionNotification();
    } else {
      this.assignmentDetailsGrid.endEdit();
      if (this.assignmentDetailsGrid.isEdit) {
        this.commonService.showNotification('warning', 'Can not add assignment if trasaction is being edited!', 'center', 5000);
      } else {
        // An empty new row, open for editing; it joins this.assignments when it is saved.
        this.assignmentsGrid.startDraft();
      }
    }
  }

  onAssignmentActionIconClick(event: GridActionIconClickEvent) {
    const row: any = this.assignments.find(a => a.rowId === event.row['rowId']);
    if (!row) return;
    const locked = this.assignmentActionLockReason(row);
    if (locked) {
      this.commonService.showNotification('info', locked);
    } else if (this.assignmentsReadOnly) {
      this.commonService.showPermissionNotification();
    } else if (event.iconKey === 'delete') {
      this.deleteAssignment(row);
    } else if (!this.assignmentDetailsGrid.isEdit && !this.assignmentEditing) {
      row['callGroup'] = this.data.callGroup;
      this.openEditAssignmentPopup(row);
    } else {
      this.commonService.showNotification('warning', 'Assignment or Transaction is in edit mode!');
    }
  }


  // ---- Transactions on @inavista/components ---------------------------------------------------------------------
  // The rows are this.assignmentDetails (LocalRowsGridApi, no endpoint). The column list stays assignmentDetailGrid
  // and every column's `edit` is drawn in its cell with @inavista/components controls (CellEditorHost), so the editors and every rule in
  // them run as before. this.assignmentDetailsGrid is a stand-in with the members the old code used on the
  // Syncfusion grid (isEdit, dataSource, getColumnByField, refresh, endEdit...), so that code runs unchanged.

  private createTransactionsGridShim(): any {
    const self = this;
    const column = (field: string) => {
      const c = self.assignmentDetailGrid?.columns?.find(col => col.field === field);
      if (!c) return { visible: false, validationRules: {} };
      return {
        get validationRules() { return c.validationRules ?? (c.validationRules = {}); },
        set validationRules(rules) { c.validationRules = rules; },
        get visible() { return self.isTransactionColumnVisible(field); },
        set visible(visible: boolean) {
          const changed = (c.visible !== false) !== visible;
          c.visible = visible;
          // A code-set column (Estimated Qty, by the order's mode): the grid is configured again, so the user's layout
          // is not touched. Other columns follow the user's layout.
          if (changed && c.showInColumnChooser === false) self.reconfigureTransactionsGrid();
          else if (c.showInColumnChooser !== false) self.setTransactionColumnVisible(field, visible);
        },
      };
    };
    return {
      get isEdit() { return self.transactionEditing; },
      get dataSource() { return self.assignmentDetails; },
      set dataSource(rows) { self.assignmentDetails = rows; },
      get columns() { return self.assignmentDetailGrid?.columns ?? []; },
      allowSorting: true, allowReordering: true, allowFiltering: true,
      getColumnByField: column,
      refresh: () => self.refreshTransactionsGrid(),
      refreshColumns: () => self.refreshTransactionsGrid(),
      // Leaving the open row saves it, as endEdit did.
      endEdit: () => self.transactionsGrid?.saveBatch(),
    };
  }

  // After initAssignmentDetailsGrid: the editor templates are drawn for txEditFields, then the grid is configured.
  setupTransactionsGrid() {
    const { hosted, builtIn } = transactionEditFields(this.assignmentDetailGrid.columns);
    this.txBuiltInEditFields = builtIn;
    this.txEditFields = hosted;
    setTimeout(() => {
      const templates = this.txEditorTemplates.toArray();
      const ctx: TransactionsGridContext = {
        persistenceKey: ISC_TRANSACTIONS_PERSISTENCE_KEY,
        // As before: Add to Cart and Create Purchase Order for ISC managers and supervisors (cart permission).
        commands: iscTransactionCommands(this.isIscManager || this.isIscSupervisor),
        materialCostType: IscCostTypes.material,
        // The ISC fields, light blue as before (header and cells).
        columnBackgrounds: Object.fromEntries(this.iscRelatedFields.map(field => [field, '#a5d2fe'])),
        columns: this.assignmentDetailGrid.columns,
        editors: Object.fromEntries(this.txEditFields.map((field, i) => [field, templates[i]])),
        editLockReason: () => this.transactionEditLockReason(),
        actionLockReason: () => this.isEditable ? null : 'Transactions can be changed while the order is In Progress.',
        addDisabledReason: () => this.isAddTransactionDisabled ? 'Transactions can be added while the order is In Progress.' : null,
        validate: row => this.validateTransaction(row),
      };
      this.txSchema = LocalRowsGridApi.schema([
        ...transactionFields(this.assignmentDetailGrid.columns).map(c => [c.field, c.type === 'number' ? 'decimal' : c.type === 'date' ? 'datetime' : 'nvarchar'] as [string, string]),
        [TRANSACTION_OPEN_FIELD, 'nvarchar'],
      ]);
      this.txContext = ctx;
      this.transactionsConfig = buildTransactionsGridConfig(ctx);
      this.transactionsActionIcons = buildTransactionsActionIcons(ctx);
      this.refreshTransactionsGrid();
    });
  }

  // The column list changed (a code-set column shown or hidden, e.g. Estimated Qty by the order's mode).
  reconfigureTransactionsGrid() {
    if (!this.txContext) return;
    const { hosted, builtIn } = transactionEditFields(this.assignmentDetailGrid.columns);
    this.txBuiltInEditFields = builtIn;
    this.txEditFields = hosted;
    // The grid reads its hidden / always-shown columns when it is created: it is drawn again with the new list.
    this.transactionsConfig = null;
    setTimeout(() => {
      const templates = this.txEditorTemplates.toArray();
      this.txContext = { ...this.txContext, editors: Object.fromEntries(this.txEditFields.map((f, i) => [f, templates[i]])) };
      this.transactionsConfig = buildTransactionsGridConfig(this.txContext);
      setTimeout(() => {
        this.refreshTransactionsGrid();
        // A layout saved while Estimated Qty was hidden puts it last: back before Quantity, as in the old grid.
        setTimeout(() => this.placeEstimatedQty(), 500);
      });
    });
  }

  private placeEstimatedQty() {
    const state = this.transactionsGrid?.captureState();
    const order = state?.columnOrder;
    if (!order || !this.isTransactionColumnVisible('estimateQty')) return;
    const rest = order.filter(c => c !== 'estimateQty');
    const at = rest.indexOf('qty');
    if (at < 0 || order.indexOf('estimateQty') === at) return;
    rest.splice(at, 0, 'estimateQty');
    this.transactionsGrid.applyState({ ...state, columnOrder: rest });
  }

  /** The column's `edit`, read at draw time: ngOnChanges can replace a column (the Reference Activity one). */
  txEditDef(field: string) {
    return this.assignmentDetailGrid?.columns?.find(c => c.field === field)?.edit;
  }

  // The rows the grid shows: the transactions not deleted, each foreign-key column with its list's text, as the
  // Syncfusion foreign-key columns showed it (costTypeCode keeps the code for the Parts Order rule).
  refreshTransactionsGrid() {
    if (!this.transactionsConfig) return;
    const columns = this.assignmentDetailGrid.columns;
    const fk = columns.filter(c => c.foreignKeyField && c.foreignKeyValue && c.dataSource);
    const rows = this.assignmentDetails.filter(d => !d.isDeleted).map(d => {
      const row = { ...d, costTypeCode: d.costType };
      for (const c of fk) {
        const item = (c.dataSource as any[]).find(x => x[c.foreignKeyField] === d[c.field]);
        if (item) row[c.field] = item[c.foreignKeyValue];
      }
      return row;
    });
    this.transactionsRows.set(TRANSACTIONS_URL, this.txSchema, rows);
    this.transactionsGrid?.refresh();
  }

  /** The transaction a grid row stands for: the page's own object (a new row: the one Add built). */
  transactionRowFor(row: any) {
    return row?.rowId == null ? this.pendingNewTransaction : this.assignmentDetails.find(d => d.rowId === row.rowId);
  }

  isTransactionColumnVisible(field: string): boolean {
    const own = this.assignmentDetailGrid?.columns?.find(col => col.field === field);
    // A column kept out of the chooser is shown or hidden by the code alone (Estimated Qty).
    if (own?.showInColumnChooser === false) return own.visible !== false;
    const visibility = this.transactionsGrid?.captureState().columnVisibility;
    if (visibility && field in visibility) return visibility[field];
    const c = this.assignmentDetailGrid?.columns?.find(col => col.field === field);
    return !!c && c.visible !== false;
  }

  setTransactionColumnVisible(field: string, visible: boolean) {
    if (!this.transactionsGrid) return;
    const state = this.transactionsGrid.captureState();
    this.transactionsGrid.applyState({ ...state, columnVisibility: { ...(state.columnVisibility ?? {}), [field]: visible } });
  }

  // The Syncfusion validation the old grid ran on save: each shown column's rules on its editor's value.
  validateTransaction(row: any): GridRowProblem | null {
    for (const c of this.assignmentDetailGrid.columns) {
      const rules = c.validationRules;
      if (!rules || !this.isTransactionColumnVisible(c.field)) continue;
      const open = this.txOpenEditors.get(c.field);
      if (!open && !this.txBuiltInEditFields.includes(c.field)) continue;
      const value = open ? open.read() : row[c.field];
      const required = Array.isArray(rules.required) ? rules.required[0] : rules.required;
      if (required && (value === null || value === undefined || value === '')) {
        return { column: c.field, message: `${c.headerText}: This field is required.` };
      }
      for (const [rule, fails] of [['max', (v, n) => +v > +n], ['min', (v, n) => +v < +n]] as [string, (v: any, n: any) => boolean][]) {
        if (rules[rule] == null || value === null || value === undefined || value === '') continue;
        const [limit, message] = Array.isArray(rules[rule]) ? rules[rule] : [rules[rule]];
        if (fails(value, limit)) {
          return { column: c.field, message: message ?? `${c.headerText}: Please enter a value ${rule === 'max' ? 'less' : 'greater'} than or equal to ${limit}.` };
        }
      }
    }
    return null;
  }

  // Why a transaction can't be opened (the old allowEditing and beginEdit cancels), or null.
  transactionEditLockReason(): string | null {
    if (!this.isEditable) return 'Transactions can be changed while the order is In Progress.';
    if (this.transactionsReadOnly) return 'You do not have permission to change transactions.';
    if (this.assignmentEditing) return 'Assignment is in edit mode!';
    return null;
  }

  // A double click on a locked row says why, as the old beginEdit did.
  onTransactionDoubleClick() {
    if (!this.lastClickedTransaction || !this.isEditable) return;
    if (this.transactionsReadOnly) this.commonService.showPermissionNotification();
    else if (this.assignmentEditing) this.commonService.showNotification('warning', 'Assignment is in edit mode! ');
  }

  // The row opened: the old actionBegin('beginEdit'), the editors draw, then the old actionComplete('beginEdit').
  onTransactionEditStart(event: GridRowEditStartEvent) {
    const rowData = this.transactionRowFor(event.row);
    if (!rowData) return;
    this.transactionEditing = true;
    this.onAssignmentDetailsActionBegin({ requestType: 'beginEdit', rowData });
    this.txHiddenEditFields = transactionFields(this.assignmentDetailGrid.columns)
      .filter(c => c.edit && !this.isTransactionColumnVisible(c.field))
      .map(c => c.field);
    this.txHiddenRow = rowData;
    // Leaving the row always saves it, as the Syncfusion grid did: the row counts as changed from the start, so
    // closing it always says so (commit or revert) and transactionEditing can't stay set.
    const marked = this.transactionsGrid?.setDraftValue(TRANSACTION_OPEN_FIELD, String(Date.now()));
    setTimeout(() => {
      if (!marked) this.transactionsGrid?.setDraftValue(TRANSACTION_OPEN_FIELD, String(Date.now()));
      this.onTransactionGridActionComplete({ requestType: 'beginEdit', rowData }, this.assignmentDetailsGrid);
    });
  }

  // Enter, the ✓ icon, a click elsewhere or the popup's Save: every open editor's value goes into the row, as the
  // Syncfusion grid did, then the old actionComplete('save').
  onTransactionCommit(commit: GridRowCommitEvent) {
    const target = this.transactionRowFor(commit.row);
    if (!target) return;
    for (const field of this.txBuiltInEditFields) {
      if (field in commit.row) target[field] = commit.row[field];
    }
    for (const [field, edit] of this.txOpenEditors) target[field] = edit.read();
    this.txHiddenRow = null;
    if (commit.isDraft) this.assignmentDetails.push(target);
    this.pendingNewTransaction = null;
    this.transactionEditing = false;
    this.onTransactionGridActionComplete({ requestType: 'save', data: target }, this.assignmentDetailsGrid);
    this.refreshTransactionsGrid();
  }

  // Esc or ✕: as the old actionComplete('cancel'). A new row was never added to the list.
  onTransactionRevert(event: { row: any; isDraft: boolean }) {
    this.transactionEditing = false;
    this.txHiddenRow = null;
    if (event.isDraft) {
      this.pendingNewTransaction = null;
      this.resetTempValuesForTransaction();
      return;
    }
    const rowData = this.transactionRowFor(event.row);
    if (rowData) this.onTransactionGridActionComplete({ requestType: 'cancel', rowData, data: rowData }, this.assignmentDetailsGrid);
  }

  onTransactionsToolbarAction(event: { key: string }) {
    if (event.key === ADD_TRANSACTION_ACTION) {
      this.onAssignmentDetailsToolbarClick({ item: { id: 'add-new-assignment-detail' } } as any, this.assignmentDetailsGrid);
    }
  }

  // The old command column: disabled while the order is not In Progress, then the same handler as before.
  onTransactionActionIconClick(event: GridActionIconClickEvent) {
    if (!this.isEditable) return;
    const rowData = this.transactionRowFor(event.row);
    if (rowData) this.onAssignmentDetailsCommandClick({ commandColumn: { title: event.iconKey }, rowData });
  }

  // Item and Description open the item, as before.
  onTransactionHyperlink(event: GridHyperlinkClickEvent) {
    const rowData = this.transactionRowFor(event.row);
    if (rowData) this.showMasterItemCodePopup(rowData);
  }

  setTempValuesForTransaction(data) {
    // this.assignmentId = +data.tempId;
    this.activityId = data.activityId;
    this.assignmentDetailReferenceActivityDescription = data.referenceActivityDescription;
    this.assignmentDetailReferenceActivityCode = data.referenceActivityCode;
    this.assignmentDetailServiceTypeCode = data.serviceTypeCode;
  }

  onAssignmentDetailsActionBegin(args) {
    if (args.requestType === 'beginEdit') {
      this.taxAmount = 0;
      this.getPriceForItem = false;
      this.serviceItemGroup = args.rowData.serviceItemGroup;
      this.rowServiceItemGroup = args.rowData.serviceItemGroup;
      this.tempUnit = this.getUnit(args.rowData.costType);
      if (args.rowData.costType === IscCostTypes.material) {
        if (this.skipBeginEditEvent) {
          this.skipBeginEditEvent = false;
        }
        this.getItemList(args.rowData);

      }
      this.setItemCodeValidation(args.rowData.costType);
      if (this.assignmentEditing) {
        args.cancel = true;
        this.commonService.showNotification('warning', 'Assignment is in edit mode! ');
      } else {
        this.assignmentDetailsGrid.getColumnByField('qty').validationRules = { required: true };
      }
      if (this.transactionsReadOnly) {
        args.cancel = true;
        this.commonService.showPermissionNotification();
      }
      this.setTempValuesForTransaction(args.rowData);
    } else if (args.requestType === 'delete') {
      args.cancel = true;
      if (this.transactionsReadOnly) {
        this.commonService.showPermissionNotification();
      } else if (this.isEditable) {
        this.deleteTransaction(args.data[0]);
      }
    }
  }

  setAssignmentRow(assignment) {
    const currentTime = this.checkinTime ? new Date(this.checkinTime) : null;
    const rowId = this.getMaxRowId(this.assignments) + 1;
    assignment.rowId = rowId;
    assignment.assignmentId = 0;
    assignment.activityId = rowId * 10;
    assignment.tempId = this.getTempId();
    assignment.description = "";
    assignment.serviceTypeCode = "";
    assignment.serviceTypeDescription = "";
    assignment.referenceActivityCode = "";
    assignment.referenceActivityDescription = "";
    assignment.reportedProblem = "";
    assignment.reportedProblemDescription = "";
    assignment.solutionCode = "";
    assignment.solutionDescription = "";
    assignment.priority = this.priorities?.find(priority => priority.text === 'Manual Action' || priority.text === 'Low')?.value;
    assignment.startDate = currentTime;
    assignment.endDate = null;
    assignment.isDeleted = false;
    return assignment;
  }

  getTempId() {
    const assignments = this.assignments.filter(assignment => !assignment.isDeleted);
    if (assignments.length) {
      let tempId = 1;
      assignments.forEach(assignment => {
        if (!isNaN(assignment.tempId) && +assignment.tempId > +tempId) {
          tempId = +assignment.tempId;
        }
      });
      return tempId + 1;
    } else {
      return 1;
    }
  }

  initAssignmentDetailsGrid() {
    const laborFieldHeader = this.USER.company === Companies.kingslynn ? 'Labour Type' : 'Labor Type';
    this.assignmentDetailGrid = {
      toolbar: [],
      filterSettings: { type: 'Menu' },
      columns: [
        { field: 'rowId', type: 'number', isPrimaryKey: true, showInColumnChooser: false, visible: false },
        { field: 'assignmentDetailId', headerText: 'ID', width: 140, textAlign: 'Left', visible: false, showInColumnChooser: false },
        {
          field: 'assignmentId', headerText: 'Reference Activity', width: 148, filter: { type: 'Excel' }, textAlign: 'Left', validationRules: { required: true },
          foreignKeyValue: 'referenceActivityDescription', foreignKeyField: 'tempId', showInColumnChooser: false, dataSource: this.assignments, edit: this.editAssignment()
        },
        { field: 'referenceActivityCode', headerText: 'Reference Activity', width: 184, filter: { type: 'Excel' }, textAlign: 'Left', visible: false, showInColumnChooser: false, validationRules: { required: true } },
        { field: 'referenceActivityDescription', headerText: 'Term Description', clipMode: 'EllipsisWithTooltip', visible: false, showInColumnChooser: false },
        {
          field: 'costType', headerText: 'Cost Type', width: 137, textAlign: 'Left', filter: { type: 'Excel' }, showInColumnChooser: false,
          foreignKeyValue: 'text', foreignKeyField: 'value', dataSource: this.costTypes, edit: this.editCostType(), validationRules: { required: true }
        },
        { field: 'subCostType', headerText: 'Subcost Type', width: 137, textAlign: 'Left', filter: { type: 'Excel' }, showInColumnChooser: false, foreignKeyValue: 'text', foreignKeyField: 'value', dataSource: IscSubCostTypeList, edit: this.editSubCostType() },
        { field: 'comments', headerText: 'Comments', width: 150, textAlign: 'Left', filter: { type: 'Excel' }, allowEditing: true, showInColumnChooser: true, visible: true, validationRules: { required: false } },
        { field: 'itemCode', headerText: 'Item', width: 175, textAlign: 'Left', filter: { type: 'Excel' }, showInColumnChooser: false, edit: this.editItem(), validationRules: { required: true } },
        { field: 'itemDescription', headerText: 'Description', width: 195, type: 'string', textAlign: 'Left', edit: this.editItemDescription(), showInColumnChooser: false },
        { field: 'estimateQty', headerText: 'Estimated Qty', textAlign: 'Right', width: 130, format: 'n2', showInColumnChooser: false, visible: this.data.mode === ModeList.actual && this.data.estimateApproved, type: 'number', allowEditing: false },
        { field: 'qty', headerText: 'Quantity', textAlign: 'Right', type: 'number', showInColumnChooser: false, width: 130, format: 'n2', step: 0.1, decimals: 2, validateDecimalOnType: true, edit: this.editQuantity(), validationRules: { required: true } },
        { field: 'mileage', headerText: 'Distance (KM/MI)', textAlign: 'Right', type: 'number', showInColumnChooser: false, width: 166, format: 'n2', step: 0.1, decimals: 2, validateDecimalOnType: true, edit: this.editMileage(), validationRules: { required: false } },
        // { field: 'addtMileageCharged', headerText: 'Addt Mile Chg', textAlign: 'Right', type: 'number', showInColumnChooser: false, width: 130, format: 'n2', step: 0.1, decimals: 2, validateDecimalOnType: true, validationRules: { required: false }, allowEditing: false, edit: this.editAdditionalMileageCharge() },
        { field: 'price', headerText: 'Price', textAlign: 'Right', type: 'number', showInColumnChooser: false, width: 110, format: 'n2', edit: this.editPrice(), validationRules: { required: true } },
        { field: 'iscDiscountAmount', headerText: 'ISC Discount Amount', type: 'number', width: 160, showInColumnChooser: false, textAlign: 'Right', format: 'n2', edit: this.editIscDiscountAmount() },
        { field: 'totalAmount', headerText: 'Total Amount', width: 160, type: 'number', textAlign: 'Right', showInColumnChooser: false, format: 'n2', edit: this.editTotalAmount() },
        { field: 'warrantyCoverage', headerText: 'Warranty Amount', type: 'number', width: 160, format: 'n2', textAlign: 'Right', allowEditing: false, visible: true, edit: this.editWarrantyAmount() },
        { field: 'contractCoverage', headerText: 'Contract Amount', type: 'number', width: 160, format: 'n2', textAlign: 'Right', allowEditing: false, visible: true, edit: this.editContractAmount() },
        { field: 'customerPrice', headerText: 'Customer Price', type: 'number', showInColumnChooser: true, textAlign: 'Right', width: 150, format: 'n2', edit: this.editCustomerPrice(), validationRules: { required: true } },
        { field: 'discountAmount', headerText: 'Customer Discount Amount', type: 'number', width: 160, showInColumnChooser: false, textAlign: 'Right', format: 'n2', edit: this.editDiscountAmount() },
        { field: 'customerTotalAmount', headerText: 'Customer Total Amount', width: 196, type: 'number', textAlign: 'Right', showInColumnChooser: true, format: 'n2', edit: this.editCustomerTotalAmount() },
        {
          field: 'unit', headerText: 'Unit', textAlign: 'Left', type: 'string', width: 150, visible: false, filter: { type: 'Excel' },
          foreignKeyValue: 'text', foreignKeyField: 'value', dataSource: this.units, edit: this.editUnit()
        },
        { field: 'laborType', headerText: laborFieldHeader, width: 145, type: 'string', textAlign: 'Left', allowEditing: false, edit: this.editLaborType(), visible: false, filter: { type: 'Excel' }, },
        { field: 'warehouse', headerText: 'Warehouse', width: 145, type: 'string', textAlign: 'Left', allowEditing: false, edit: this.editTransactionWarehouse(), visible: false, filter: { type: 'Excel' }, },
        {
          field: 'returnReasonCode', headerText: 'Return Reason', width: 150, type: 'string', textAlign: 'Left',
          foreignKeyValue: 'text', foreignKeyField: 'value', dataSource: this.returnReasons, edit: this.editReturnReason(), visible: false, showInColumnChooser: false
        },
        { field: 'task', headerText: 'Task', type: 'string', width: 145, textAlign: 'Left', edit: this.editTask(), visible: false, filter: { type: 'Excel' }, },
        { field: 'startDate', headerText: 'Start Time', type: 'date', textAlign: 'Left', format: { type: 'date', format: 'd MMM, y h:mm a' }, width: 250, edit: this.editStartTime(), visible: false },
        { field: 'endDate', headerText: 'End Time', type: 'date', textAlign: 'Left', format: { type: 'date', format: 'd MMM, y h:mm a' }, width: 250, edit: this.editEndTime(), visible: false },
        { field: 'costComponent', headerText: 'Cost Component', width: 145, type: 'string', textAlign: 'Left', allowEditing: false, edit: this.editCostComponent(), visible: false, filter: { type: 'Excel' }, },
        { field: 'taxpercent', headerText: 'Tax %', width: 160, format: 'n3', type: 'string', textAlign: 'Left', allowEditing: false, edit: this.editTaxPercent(), visible: false },
        { field: 'taxAmount', headerText: 'Tax Amount', width: 160, format: 'n3', type: 'string', textAlign: 'Right', allowEditing: false, edit: this.editTax(), visible: false, filter: { type: 'Excel' }, },
        { field: 'customerCurrency', headerText: 'Currency', type: 'string', width: 160, textAlign: 'Left', allowEditing: false, visible: false, filter: { type: 'Excel' }, },
        {
          field: 'Actions', headerText: 'Actions', showInColumnChooser: false, textAlign: 'Center', width: 140, allowFiltering: false, allowSorting: false,
          commands: this.setTransactionActionColumn()
        }
      ]
    };
  }

  setTransactionActionColumn() {
    const commands = [
      // { title: 'Edit Assignment Detail', type: 'Edit', buttonOption: { iconCss: `fas fa-pencil-alt`, cssClass: `e-flat action-button edit-btn` } },
      { title: 'Delete Detail', type: 'Delete', buttonOption: { iconCss: `fas fa-trash`, cssClass: `e-flat action-button delete-btn` } },
      // Shown only while the row is edited: lets touch screens save or cancel without Enter/Escape.
      { title: 'Save', type: 'Save', buttonOption: { iconCss: `fas fa-check`, cssClass: `e-flat action-button` } },
      { title: 'Cancel', type: 'Cancel', buttonOption: { iconCss: `fas fa-times`, cssClass: `e-flat action-button` } }
    ];
    // cart permission required from the permissions api
    if (this.isIscManager || this.isIscSupervisor) {
      commands.unshift(
        { title: 'Add to Cart', type: 'Edit', buttonOption: { iconCss: `fa fa-cart-plus`, cssClass: 'e-flat action-button add-to-cart-btn' } },
        { title: 'Create Purchase Order', type: 'Edit', buttonOption: { iconCss: `e-btn-icon fas fa-cubes e-icons`, cssClass: `e-flat action-button buy-now-btn` } }
      );
    }
    return commands;
  }

  getMaxRowId(datasource) {
    if (datasource.length) {
      return Math.max.apply(Math, datasource.map(row => row.rowId)) || 0;
    } else {
      return 0;
    }
  }

  setAssignmentDetailRow(detail) {
    let costType = this.costTypes.find(type => type.value === IscCostTypes.material);
    const currentTime = this.checkinTime ? new Date(this.checkinTime) : null;
    detail.rowId = this.getMaxRowId(this.assignmentDetailsGrid.dataSource) + 1;
    detail.assignmentId = '';
    detail.assignmentDetailId = '';
    detail.activityId = null;
    detail.comments = '';
    detail.referenceActivityDescription = '';
    detail.referenceActivityCode = '';
    detail.serviceTypeCode = '';
    detail.serviceTypeDescription = '';
    detail.costType = costType ? costType.value : this.costTypes[0]?.value || '';
    detail.subCostType = '';
    detail.itemCode = null;
    detail.itemDescription = this.getItemDescription(detail.costType);
    detail.customerCurrency = this.customerCurrency;
    detail.qty = 1;
    detail.price = detail.costType === IscCostTypes.labor ? this.laborRate : 0;
    detail.totalAmount = 0;
    detail.customerTotalAmount = 0;
    detail.unit = this.getUnit(detail.costType);
    this.unitCode = detail.unit;
    detail.startDate = currentTime;
    this.assignmentDetailStartTimeValue = currentTime;
    detail.endDate = null;
    detail.task = this.getTask(detail.costType);
    detail.laborType = this.getLaborType(detail.costType);
    detail.warehouse = this.getWarehouse(detail.costType);
    detail.costComponent = this.getCostComponent(detail.costType);
    detail.discountAmount = 0;
    detail.warrantyCoverage = 0;
    detail.contractCoverage = 0;
    detail.taxpercent = this.getTaxRate(detail.costType);
    detail.taxAmount = 0;
    detail.returnReasonCode = null;
    detail.serviceItem = null;
    detail.isDeleted = false;
    detail.warehouse = this.data?.technicianWarehouse;
    detail.mileage = 0;
    detail.customerPrice = 0;
    detail.iscDiscountAmount = 0;
    detail.addtMileageCharged = 0;

    // detail.itemGroup = '';
    // detail.serviceItemGroup = '';
    // detail.lineNumber = this.getMaxRowId(this.assignmentDetailsGrid) + 1;
    // detail.issuedQty
    // detail.estimateQty
    // detail.invoiceAmount
    return detail;
  }

  showEstimatedQtyCol(showColumn) {
    if (this.assignmentDetailsGrid)
      this.assignmentDetailsGrid.getColumnByField('estimateQty').visible = showColumn;
  }

  getItemDescription(costType, costTypeChanged = false) {
    if (costType === IscCostTypes.labor) {
      return "Labor charge";
    } else if ([IscCostTypes.material, IscCostTypes.other].includes(costType) || !costType) {
      return null;
    }
  }

  getTaxRate(costType) {
    if (this.taxRates) {
      const laborTypeKeys = {
        [IscCostTypes.labor]: 'LABMOBILE',
        [IscCostTypes.material]: 'MATERIAL',
        [IscCostTypes.other]: 'OTHER'
      }
      let taxRateItem = this.taxRates.find(taxRate => taxRate.productCategory === laborTypeKeys[costType]);
      if (taxRateItem && taxRateItem.taxRatePercentage) {
        return taxRateItem.taxRatePercentage;
      } else {
        return 0
      }
    } else {
      return 0;
    }
  }

  getCostComponent(costType: string) {
    if (costType === IscCostTypes.labor) {
      return this.commonService.userDefaults && this.commonService.userDefaults.lbrCCMP ? this.commonService.userDefaults.lbrCCMP : null;
    } else if (costType === IscCostTypes.material) {
      return this.commonService.userDefaults && this.commonService.userDefaults.mtlCCMP ? this.commonService.userDefaults.mtlCCMP : null;
    } else if (costType === IscCostTypes.other) {
      return this.commonService.userDefaults && this.commonService.userDefaults.traCallCCMP ? this.commonService.userDefaults.traCallCCMP : null;
    }
  }

  getWarehouse(costType: string) {
    if (costType === IscCostTypes.material) {
      return this.warehouse;
    } else {
      return null;
    }
  }

  getLaborType(costType: string) {
    if (costType === IscCostTypes.labor) {
      return this.commonService.userDefaults?.lbrCHLT ? this.commonService.userDefaults.lbrCHLT : null;
    } else {
      return null;
    }
  }

  getWarrantyAmount(row?) { //row: if called from calculateAmounts()
    if (row) {
      return row.warrantyCoverage;
    } else {
      let warrantyPercent = 0, warrantyCoverageIndex;
      let costType = this.costTypeObject?.value && (this.costTypeObject?.value as string)?.toLowerCase();
      warrantyCoverageIndex = this.equipmentInfoData?.warrantyDescriptionObj?.findIndex(war => war.costType.toLowerCase() === costType || war.costType === 'all');
      if (warrantyCoverageIndex > -1) {
        warrantyPercent = this.equipmentInfoData.warrantyDescriptionObj[warrantyCoverageIndex].percentageCoverage;
      }
      let totalPrice = (this.quantityObject.value * this.customerPriceValue) - this.discountAmountObject.value;
      return totalPrice > 0 ? +(totalPrice * warrantyPercent / 100)?.toFixed(2) : 0;
    }
  }

  getContractAmount(row?) { //row: if called from calculateAmounts()
    if (row) {
      return row.contractCoverage;
    } else {
      let contractPercent = 0, contractCoverageIndex;
      let costType = this.costTypeObject.value && (this.costTypeObject.value as string).toLowerCase();
      contractCoverageIndex = this.equipmentInfoData?.serviceContractDescriptionObj?.findIndex(contract => contract.costType.toLowerCase() === costType || contract.costType === 'all');
      if (contractCoverageIndex > -1) {
        contractPercent = this.equipmentInfoData?.serviceContractDescriptionObj[contractCoverageIndex].percentageCoverage;
      }

      let totalPrice = (this.quantityObject.value * this.customerPriceValue) - this.discountAmountObject.value;
      return totalPrice > 0 ? +(totalPrice * contractPercent / 100)?.toFixed(2) : 0;
    }
  }

  getUnit(costType: string) {
    if (costType === IscCostTypes.labor) {
      return this.units.find(unit => unit.description === 'Hours').value;
    } else if (costType === IscCostTypes.material || costType === IscCostTypes.other) {
      const unit = this.subcostTypeObject?.value === SubCostTypes.mileage ? this.units.find(unit => unit.description === 'Miles') : this.units.find(unit => unit.description === 'Each');
      return unit ? unit.value : this.units[0].value;
    } else {
      return null;
    }
  }

  getTask(costType: string) {
    if (costType === IscCostTypes.labor) {
      return this.commonService.userDefaults && this.commonService.userDefaults.lbrCTSK ? this.commonService.userDefaults.lbrCTSK : null;
    } else {
      return null;
    }
  }

  openEditAssignmentPopup(rowData) {
    this.selectedAssignment = rowData;
    this.showAssignmentsPopup = true;
  }

  addAssignmentDetail() {
    // Built as before (defaults, warehouse, unit...). It joins this.assignmentDetails when the row is saved.
    this.pendingNewTransaction = this.setAssignmentDetailRow({});
    this.serviceOrderService.hasTransaction.next(true);
    const onlyOneAssignment = this.assignments.filter(x => !x.isDeleted).length === 1;
    this.defaultReferenceActivity = onlyOneAssignment && this.assignments.find(x => !x.isDeleted) || null;
    this.transactionsGrid?.startDraft();
  }

  onAssignmentDetailsToolbarClick(args: ToolbarClickEventArgs, grid: any) {
    if (args.item.id === 'add-new-assignment-detail') {
      if (this.isAddTransactionDisabled) { return; } // the button is greyed out
      this.assignmentDetailsGrid.endEdit();
      if (!this.assignmentDetailsGrid.isEdit) {
        if (this.assignments && this.assignments.length) {
          if (this.transactionsReadOnly) {
            this.commonService.showPermissionNotification();
          } else {
            this.assignmentsGrid?.saveBatch();
            if (!this.assignmentEditing) {
              this.addAssignmentDetail();
            }
          }
        } else {
          this.commonService.showNotification('warning', 'Please add an assignment first to add transaction!', 'center', 5000);
        }
      } else {
        this.commonService.showNotification('warning', 'There is a row in transaction grid, which is already in edit mode!', 'center', 5000);
      }
    } else if (args.item.id === 'cart-icon') {
      grid.endEdit();
      if (!grid.isEdit) {
        this.showPartsCatalogPopup = true;
      } else {
        this.commonService.showNotification('warning', 'Transaction grid is in edit mode!');
      }
    }
  }

  refreshPriceAndAddToCart(item, rowData) {
    this.showLoader = true;
    this.iscService.refreshPrice(item, rowData.qty).subscribe({
      next: (res: ApiResponse) => {
        if (res.isSuccessful) {
          this.showLoader = false;
          this.addToCart(
            this.setCartData(res.result.result, rowData)
          );
        } else {
          this.commonService.showNotification('warning', res.message);
          this.showLoader = false;
        }
      },
      error: (err: Error) => {
        this.commonService.showNotification('warning', err.message);
        this.showLoader = false;
      }
    });
  }

  onAssignmentDetailsCommandClick(args: any) {
    if (args.commandColumn.title === 'Add to Cart') {
      args.cancel = true;
      if (args.rowData.itemStatus === 'Inactive') {
        this.handleObsoleteItem(args.rowData, 'addToCart');
      } else {
        this.refreshPriceAndAddToCart(args.rowData.itemCode, args.rowData);
      }
    } else if (args.commandColumn.title === 'Create Purchase Order') {
      if (args.rowData.itemStatus === 'Inactive') {
        this.handleObsoleteItem(args.rowData, 'createPO');
        args.cancel = true;
      } else {
        this.fromExecutionTab = [args.rowData];
        this.showCartCheckoutPopup = true;
      }
    } else if (args.commandColumn.title === 'Edit Assignment Detail') {
      args.cancel = true;
      if (this.transactionsReadOnly) {
        this.commonService.showPermissionNotification();
      } else {
        if (!this.assignmentDetailsGrid.isEdit && !this.assignmentEditing) {
          this.showAssignmentDetailsPopup = true;
          this.selectedAssignmentDetail = args.rowData;
        } else {
          this.commonService.showNotification('warning', 'Assignment or Transaction is in edit mode!');
        }
      }
    } else if (args.commandColumn.title === 'Delete Detail') {
      this.assignmentDetailAction = 'Delete';
      if (this.transactionsReadOnly) {
        this.commonService.showPermissionNotification();
      } else {
        this.deleteTransaction(args.rowData);
      }
    }
  }

  setCartData(pricing, rowData) {
    return {
      alternateItem: rowData.alternateItem,
      description: null,
      grossAmount: pricing.grossAmount.grossAmountValue,
      isDeleted: false,
      item: rowData.itemCode || rowData.item,
      itemDescription: rowData.itemDescription,
      itemDiscount: pricing.discountAmount.discountAmountValue,
      itemGroup: rowData.serviceItemGroup,
      itemPrice: pricing.bookPrice.bookPriceValue,
      listPrice: 0.25,
      lnStock: 0,
      netPrice: pricing.netAmount.netAmountValue,
      orderQty: rowData.qty,
      quantity: rowData.qty,
      serializedItem: null,
      status: rowData.itemStatus,
      technicianId: this.data.technicianId ?? this.USER.userId,
      unit: rowData.unit
    }
  }

  addToCart(rowData) {
    this.showLoader = true;
    this.iscService.addToCart(rowData).subscribe({
      next: (res: ApiResponse) => {
        if (res.isSuccessful) {
          this.commonService.showNotification('success', 'Item ' + rowData.item + ' - ' + rowData.itemDescription + '\nadded to the cart\n\n' +
            'Ordered quantity : ' + rowData.orderQty);
          this.cartCount = res.result.cartTotal;
          this.showLoader = false;
        } else {
          this.commonService.showNotification('warning', 'Due to a system error Item ' + rowData.item + ' cannot be added to the cart');
          this.showLoader = false;
        }
      },
      error: (err) => {
        this.commonService.showNotification('warning', 'Due to a system error Item ' + rowData.item + ' cannot be added to the cart');
        this.showLoader = false;
      }
    });
  }

  handleObsoleteItem(rowData, action) {
    if (rowData.alternateItem) {
      this.commonService.showConfirmation('\n <strong>' + rowData.itemCode + '-' + rowData?.itemDescription + '</strong>  is no longer available for purchase but it has an alternate item available.' + '\n\n Would you like to add the alternate item <strong>' + rowData?.alternateItem + '</strong>')
        .then(result => {
          if (result.isConfirmed) {
            this.showLoader = true;
            this.commonService.getAlternateItemData(rowData.alternateItem)
              .subscribe({
                next: (res: ApiResponse) => {
                  const alternateItem = res.result;
                  alternateItem['qty'] = rowData.qty;
                  if (action === 'addToCart') {
                    this.showLoader = false;
                    this.refreshPriceAndAddToCart(res.result.item, alternateItem);
                  } else if (action === 'createPO') {
                    rowData.assignmentId = rowData.assignmentId;
                    rowData.itemCode = res?.result?.item;
                    rowData.itemDescription = res?.result?.itemDescription;
                    rowData.unit = rowData.unit;
                    rowData.qty = rowData.qty;
                    this.fromExecutionTab = [rowData];
                    this.showLoader = false;
                    this.showCartCheckoutPopup = true;
                  }
                },
                error: (err) => {
                  this.commonService.showNotification('warning', err.message);
                  this.showLoader = false;
                }
              });
          }
        })
    } else {
      this.commonService.showNotification('error', '\nItem <strong>' + rowData.itemCode + '-' + rowData?.itemDescription + '</strong> is no longer available for purchase.');
      return false;
    }
  }

  checkBillable() {
    return this.assignments.length && this.assignments.find(assignment => this.getRefActivityCategory(assignment.referenceActivityCode) === 'Billable Service');
  }

  onTransactionGridActionComplete(args, grid) {
    if (args.requestType === 'save') {
      this.assignmentDetailsGrid.allowReordering = true;
      this.assignmentDetailsGrid.allowSorting = true;
      this.assignmentDetailsGrid.allowFiltering = true;

      const rowData = grid.dataSource.find(row => row.rowId === args.data.rowId);
      rowData.assignmentId = +(this.assignmentId ?? rowData.assignmentId);
      rowData.activityId = this.activityId ?? rowData.activityId;

      if (!this.assignmentDetailsGrid.getColumnByField('unit').visible) {
        rowData.unit = this.getUnit(rowData.costType);
      }

      if (!this.assignmentDetailsGrid.getColumnByField('warrantyCoverage').visible) {
        rowData.warrantyCoverage = this.assignmentObject.value && this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode) === 'Warranty Service' && this.getWarrantyAmount() || 0;
      }

      if (!this.assignmentDetailsGrid.getColumnByField('contractCoverage').visible) {
        rowData.contractCoverage = this.assignmentObject.value && this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode) === 'Contract Service' && this.getContractAmount() || 0;
      }

      if (!this.assignmentDetailsGrid.getColumnByField('totalAmount').visible) {
        rowData.totalAmount = this.totalAmountValue || 0;
      }

      if (!this.assignmentDetailsGrid.getColumnByField('taxpercent').visible) {
        rowData.taxpercent = this.getTaxRate(rowData.costType);
      }

      this.taxAmount = +(rowData.customerTotalAmount * (this.getTaxRate(rowData.costType) / 100)).toFixed(2);
      rowData.taxAmount = this.taxAmount || 0;

      if (!this.assignmentDetailsGrid.getColumnByField('costComponent').visible) {
        rowData.costComponent = this.getCostComponent(rowData.costType);
      }

      if (!this.assignmentDetailsGrid.getColumnByField('warehouse').visible) {
        rowData.warehouse = this.getWarehouse(rowData.costType);
      }

      if (!this.assignmentDetailsGrid.getColumnByField('laborType').visible) {
        rowData.laborType = this.getLaborType(rowData.costType);
      }

      if (!this.assignmentDetailsGrid.getColumnByField('task').visible) {
        rowData.task = this.getTask(rowData.costType);
      }

      if (!this.assignmentDetailsGrid.getColumnByField('startDate').visible) {
        rowData.startDate = rowData.startDate ? rowData.startDate : this.assignmentDetailStartTimeValue;
      }

      if (!this.assignmentDetailsGrid.getColumnByField('customerCurrency').visible) {
        rowData.customerCurrency = this.customerCurrency;
      }

      // if (!this.assignmentDetailsGrid.getColumnByField('customerPrice').visible) {
      //     rowData.customerPrice = this.customerPriceValue;
      // }

      // if (!this.assignmentDetailsGrid.getColumnByField('customerTotalAmount').visible) {
      //     rowData.customerTotalAmount = this.customerTotalAmountValue || 0;
      // }
      // Fixed (Martin, 2026-10-28): these are set only when an item is picked; a save without one cleared the row's
      // item status (which the Inactive check reads) and alternate item. Now they change only when an item was picked.
      rowData.itemStatus = this.itemStatus ?? rowData.itemStatus;
      rowData.alternateItem = this.alternateItem ?? rowData.alternateItem;
      rowData.customerPrice = this.customerPriceValue ?? rowData.customerPrice;
      rowData.customerTotalAmount = this.customerTotalAmountValue ?? rowData.customerTotalAmountValue;
      rowData.serviceTypeDescription = this.assignmentDetailServiceTypDescription ?? rowData.serviceTypeDescription;
      rowData.itemGroup = this.itemGroup ?? rowData.itemGroup;
      rowData.serviceItemGroup = this.serviceItemGroup;
      rowData.referenceActivityCode = this.assignmentDetailReferenceActivityCode ?? rowData.referenceActivityCode;
      rowData.referenceActivityDescription = this.assignmentDetailReferenceActivityDescription ?? rowData.referenceActivityDescription;
      rowData.serviceTypeCode = this.assignmentDetailServiceTypeCode ?? rowData.serviceTypeCode;
      // rowData.estQ
      rowData.transactionDescription = rowData.description;
      rowData.discountAmount = rowData.discountAmount ?? 0;
      rowData.iscDiscountAmount = rowData.iscDiscountAmount ?? 0;
      rowData.isDeleted = false;
      this.calculateAmounts(false);
      this.isTabValid = true;
      grid.refreshColumns();
      this.tempUnit = '';
      this.resetTempValuesForTransaction();
      this.serviceItemGroup = '';
      this.rowServiceItemGroup = '';
      (this.isIsc || this.isIscManager || this.isIscSupervisor) && this.showUploadReceiptMessage();
    } else if (args.requestType === 'cancel') {
      this.assignmentDetailsGrid.allowReordering = true;
      this.assignmentDetailsGrid.allowSorting = true;
      this.assignmentDetailsGrid.allowFiltering = true;
      // Fixed (Martin, 2026-10-28): Esc on a transaction not saved to the server yet deleted it. A new row is the grid's
      // own new row and never reaches this list until saved, so a cancel only drops the edit.
      this.resetTempValuesForTransaction();
    } else if (args.requestType === 'beginEdit') {
      if (args.rowData && args.rowData.referenceActivityDescription) {
        this.updateCostTypeDataSource({ itemData: args.rowData });
      }
      if (args.rowData.costType === IscCostTypes.material) {
        this.setAdvancedSearchVisible(true);
      }
      this.customerPriceValue = args.rowData.customerPrice;
      this.customerTotalAmountValue = args.rowData.customerTotalAmount;
      this.mandatoryCommentsForISC(args);
      if (this.defaultReferenceActivity) {
        this.assignmentObject.value = this.defaultReferenceActivity.tempId;
        this.defaultReferenceActivity = null;
      }
    }
  }

  mandatoryCommentsForISC(args) {
    this.assignmentDetailsGrid.getColumnByField('comments').validationRules['required'] = args.rowData && args.rowData.subCostType && args.rowData.subCostType !== SubCostTypes.travelCalloutCharge;
  }

  showUploadReceiptMessage() {
    if (this.subcostTypeObject?.value && ![SubCostTypes.travelCalloutCharge, SubCostTypes.mileage].includes(this.subcostTypeObject.value)) {
      this.commonService.showNotification('info', UPLOAD_RECEIPT_MESSAGE);
    }
  }

  resetTempValuesForTransaction() {
    this.assignmentDetailServiceTypDescription = this.itemGroup = this.serviceItemGroup = this.rowServiceItemGroup
      = this.assignmentDetailReferenceActivityCode = this.assignmentDetailReferenceActivityDescription
      = this.assignmentDetailServiceTypeCode = this.costTypeObject = this.itemCodeObject = this.itemDescriptionObject
      = this.commentsObject = this.quantityObject = this.customerPriceObject = this.discountAmountObject = this.contractAmountObject
      = this.warrantyAmountObject = this.customerTotalAmountObject = this.returnReasonObject = this.unitObject = this.assignmentObject
      = this.assignmentDetailStartTimeObject = this.assignmentDetailEndTimeObject = this.taskObject = this.taxObject = this.iscPriceObject
      = this.taxPercentObject = this.transactionWarehouseObject = this.laborTypeObject = this.iscDiscountAmountObject = this.itemStatus = this.alternateItem = null;
    this.customerPriceValue = this.customerTotalAmountValue = 0;
  }

  onAssignmentDetailDoubleClick(args: any) {
    if (this.isEditable) {
      if (this.transactionsReadOnly) {
        this.commonService.showPermissionNotification();
      } else {
        this.selectedAssignmentDetail = args.rowData;
        this.showAssignmentDetailsPopup = true;
      }
    }
  }

  saveAssignment(args: any) {
    const index = this.assignments.findIndex(assign => (args.data.assignmentId && assign.assignmentId === args.data.assignmentId) || assign.tempId === args.data.tempId);
    const assignment = {
      ...args.data,
      activityId: args.data.activityId || (this.assignments.length + 1) * 10,
      assignmentId: args.data.assignmentId || 0,
      isDeleted: false
    };
    // The Assignments grid finds rows by rowId.
    assignment.rowId = assignment.rowId || this.getMaxRowId(this.assignments) + 1;
    if (index > -1) {
      this.assignments.splice(index, 1, assignment);
    } else {
      this.assignments.push(assignment);
    }
    if (args.deleteTransactions) {
      this.deleteAssignmentDetailsByAssignment(args.data);
    }
    this.refreshAssignmentsGrid();
    this.emitData();
  }

  saveAssignmentDetail(data: any) {
    this.costComponentValue = data.costComponent;
    data.transactionDescription = data.description;
    data.isDeleted = false;
    if (data.costType !== IscCostTypes.material) {
      data.itemDescription = this.getItemDescription(data.costType);
    }
    const existingTransactionIndex = this.assignmentDetails.findIndex(tran => (tran.assignmentDetailId && tran.assignmentDetailId === data.assignmentDetailId) || (data.rowId && tran.rowId === data.rowId));
    if (existingTransactionIndex > -1) {
      this.assignmentDetails[existingTransactionIndex] = data;
    } else {
      // data.tempId = this.assignmentDetails.length + 1;
      this.assignmentDetails?.push(data);
    }
    this.assignmentDetailsGrid.dataSource = this.assignmentDetails;
    this.assignmentDetailsGrid.refresh();
    this.calculateAmounts(false);
    // this.emitData();
    this.serviceOrderService.popupLoader.next(false);
  }

  calculateAmounts(isInitialLoad: boolean) {
    this.data.salesAmount = 0;
    this.data.discountAmount = 0;
    this.data.warrantyCoverage = 0;
    this.data.contractCoverage = 0;
    this.data.tax = 0;
    this.data.totalClaimAmount = 0;
    this.assignmentDetails.filter(detail => !detail.isDeleted && detail.qty).forEach(row => {
      this.data.salesAmount += row.qty * row.customerPrice;
      this.data.discountAmount += row.discountAmount;
      this.data.warrantyCoverage += row.warrantyCoverage;
      this.data.contractCoverage += row.contractCoverage;
      this.data.tax += row.taxAmount;
      const isBillable = this.getRefActivityCategory(row?.referenceActivityCode) === 'Billable Service';
      if (!this.data?.isNationalAccount && isBillable) {
        // skip this row (Direct billing case)
      } else {
        this.data.totalClaimAmount += row.totalAmount;
      }
    });
    this.data.salesAmount = +this.data.salesAmount?.toFixed(2);
    this.data.discountAmount = +this.data.discountAmount?.toFixed(2);
    this.data.warrantyCoverage = +this.data.warrantyCoverage?.toFixed(2);
    this.data.contractCoverage = +this.data.contractCoverage?.toFixed(2);
    this.data.tax = +this.data.tax?.toFixed(2);
    this.data.totalClaimAmount = +this.data.totalClaimAmount?.toFixed(2);

    this.data.totalAmount = this.data.salesAmount - this.data.warrantyCoverage - this.data.contractCoverage - this.data.discountAmount;
    this.data.invoiceAmount = +(this.data.totalAmount + this.data.tax)?.toFixed(2);

    if (!isInitialLoad) {
      this.emitData();
    }
  }

  emitData() {
    this.tabUpdated.emit({
      ...this.data,
      assignments: this.assignments,
      assignmentDetails: this.assignmentDetails
    });
  }

  deleteAssignment(data: any) {
    this.commonService.showConfirmation('Are you sure you want to delete this assignment? Corresponding transactions will also be deleted!')
      .then(result => {
        if (result.isConfirmed) {
          const index = this.assignments.findIndex(assgn => assgn.rowId === data.rowId);
          if (index > -1) {
            this.deleteAssignmentDetailsByAssignment(data);
            if (this.assignments[index].assignmentId) {
              this.assignments[index].isDeleted = true;
            } else {
              this.assignments.splice(index, 1);
            }
            this.updateActivityId();
            this.emitData();
            this.refreshAssignmentsGrid();
          }
        }
      });
  }

  deleteAssignmentDetailsByAssignment(assignment: any) {
    // Fixed (Martin, 2026-10-28): splicing a copy by the original's index removed the wrong rows when the assignment had
    // two or more unsaved transactions. Same rule: a saved transaction is marked deleted, an unsaved one is dropped.
    const details = this.assignmentDetails.filter(detail => {
      if (detail.assignmentId === assignment.tempId || detail.assignmentId === assignment.assignmentId) {
        if (detail.assignmentDetailId) {
          detail.isDeleted = true;
          return true;
        }
        return false;
      }
      return true;
    });
    this.assignmentDetails = details;
    this.assignmentDetailsGrid.dataSource = this.assignmentDetails;
    this.serviceOrderService.hasTransaction.next(this.assignmentDetails.filter(x => !x.isDeleted).length > 0);
    this.calculateAmounts(false);
    this.assignmentDetailsGrid.refresh();
  }

  updateActivityId() {
    this.assignments.filter(assign => !assign.isDeleted).forEach((row, index) => {
      row.activityId = (index + 1) * 10;
      this.updateDetailsOnAssignmentDeletion(row);
      return row;
    });
  }

  updateDetailsOnAssignmentDeletion(assignment) {
    this.assignmentDetails.map(det => {
      if (assignment.tempId === det.assignmentId) {
        det.activityId = assignment.activityId;
      }
    });
  }

  deleteTransaction(data) {
    this.commonService.showConfirmation('Are you sure you want to delete this transaction?')
      .then(result => {
        if (result.isConfirmed) {
          const index = this.assignmentDetails.findIndex(assgnDet => assgnDet.rowId === data.rowId);
          if (index > -1) {
            if (this.assignmentDetails[index].assignmentDetailId) {
              this.assignmentDetails[index].isDeleted = true;
            } else {
              this.assignmentDetails.splice(index, 1);
            }
            this.serviceOrderService.hasTransaction.next(this.assignmentDetails.filter(x => !x.isDeleted).length > 0);
            this.assignmentDetailsGrid.dataSource = this.assignmentDetails;
            this.assignmentDetailsGrid.refresh();
            this.calculateAmounts(false);
          }
        }
      })
  }

  onClose() {
    this.showLoader = false;
  }

  partsOrderSaved(updatedData) {
  }

  hasTransaction(assignment) {
    const index = (this.assignmentDetailsGrid.dataSource as any).findIndex(ad => ad.assignmentId === assignment.tempId);
    return index > -1;
  }

  updateRefActivityDS(existingRefActivities) {
    const createdDate = new Date(this.data?.orderDateLN ? this.data?.orderDateLN : this.data?.soCreatedDate).setHours(0, 0, 0, 0);
    return this.referenceActivities.filter(activity => {
      if (activity.description === 'Contract Service' && this.equipmentInfoData) {
        if (this.equipmentInfoData?.serviceContractCode && this.equipmentInfoData.serviceContractDescriptionObj && this.equipmentInfoData.serviceContractDescriptionObj.length) {
          const index = this.equipmentInfoData.serviceContractDescriptionObj.findIndex(contract => new Date(contract.expiryDate) >= new Date(createdDate));
          return index > -1 ? !existingRefActivities.includes(activity.value) : false;
        } else {
          return false;
        }
      } else if (activity.description === 'Warranty Service' && this.equipmentInfoData) {
        if (this.equipmentInfoData.warrantyCode && this.equipmentInfoData.warrantyDescriptionObj && this.equipmentInfoData.warrantyDescriptionObj.length) {
          const index = this.equipmentInfoData.warrantyDescriptionObj.findIndex(warranty => new Date(warranty.expiryDate) >= new Date(createdDate));
          return index > -1 ? !existingRefActivities.includes(activity.value) : false;
        } else {
          return false;
        }
      } else {
        return !existingRefActivities.includes(activity.value);
      }
    });
  }

  editAssignment(): CellEdit {
    return {
      read: () => this.assignmentObject?.value,
      destroy: () => this.assignmentObject?.destroy(),
      open: args => {
        return this.assignmentObject = new DropdownEditor({
          dataSource: this.assignments.filter(assignment => !assignment.isDeleted),
          fields: { value: 'tempId', text: 'referenceActivityDescription' },
          value: args.rowData.assignmentId,
          allowFiltering: true,
          popupWidth: '250px',
          change: event => {
            this.USER.company === Companies.conway && this.updateCostTypeDataSource(event);
            this.setTempValuesForTransaction(event.itemData);
            if (args?.rowData.assignmentDetailId) { // To reset the row on this change
              this.costTypeObject.value = null;
            }
            if (this.discountAmountObject) {
              this.discountAmountObject.enabled = this.getRefActivityCategory(event.itemData.referenceActivityCode) === 'Billable Service';
            }
            this.iscDiscountAmountObject.enabled = this.isIscDiscountEnabled();
            this.iscPriceObject.enabled = this.isIscPriceEnabled();
            this.recalculations(args);
          }
        });
      }
    }
  }

  recalculations(args) {
    // do all the recalculations based on the category of the transaction (Billable Service, Contract Service, Warranty Service or Other)

    const qty = this.quantityObject ? this.quantityObject.value : args.rowData.qty;
    const customerPrice = this.customerPriceObject ? +this.customerPriceObject.value.toFixed(2) : +this.customerPriceValue.toFixed(2);
    let iscPrice = this.iscPriceObject ? this.iscPriceObject.value : args.rowData.price;
    let discount = this.discountAmountObject ? this.discountAmountObject.value : args.rowData.discountAmount;

    const isWarranty = this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode) === 'Warranty Service';
    const isContract = this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode) === 'Contract Service';
    const isBillable = this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode) === 'Billable Service';

    if (!isBillable && !isWarranty && !isContract) {
      discount = customerPrice * qty;
      if (this.discountAmountObject) {
        this.discountAmountObject.value = customerPrice && qty ? customerPrice * qty : 0;
        this.discountAmountObject.max = customerPrice && qty ? customerPrice * qty : null;
      }
    } else {
      this.discountAmountObject.value = 0;
      iscPrice = this.iscPriceObject.value = 0;
      discount = 0;
      if (isBillable && this.costTypeObject.value === CostTypes.material) {
        const itemCode = this.itemCodeObject.value ?? args.rowData.itemCode;
        const unit = this.unitObject?.value ?? args.rowData?.unit;
        const qty = this.quantityObject?.value ?? args.rowData.qty;
        this.getItemPrice(itemCode, unit, args.rowData, qty);
      }
    }
    const tax = this.getTaxRate(this.costTypeObject.value);
    const warranty = this.quantityObject.value * (this.assignmentObject.value && isWarranty && this.getWarrantyAmount() || 0) || 0;
    const contract = this.quantityObject.value * (this.assignmentObject.value && isContract && this.getContractAmount() || 0) || 0;

    if (this.warrantyAmountObject) {
      this.warrantyAmountObject.value = warranty;
    }
    if (this.contractAmountObject) {
      this.contractAmountObject.value = contract;
    }
    this.calculateTotalAmount({ qty, customerPrice, iscPrice, discount, tax, warranty, contract }, args.rowData);
  }

  checkWarrantyContractCoverage(coverages) {
    let costTypes = this.costTypes;
    const createdDate = new Date(this.data?.orderDateLN ? this.data?.orderDateLN : this.data?.soCreatedDate).setHours(0, 0, 0, 0);
    coverages.forEach(x => {
      if (x.costType === 'all' && new Date(x.expiryDate) < new Date(createdDate)) {
        costTypes = [];
      } else if (x.costType.toLowerCase() === 'material' && new Date(x.expiryDate) < new Date(createdDate)) {
        costTypes = costTypes.filter(x => x.value !== IscCostTypes.material);
      } else if (x.costType.toLowerCase() === 'labor' && new Date(x.expiryDate) < new Date(createdDate)) {
        costTypes = costTypes.filter(x => x.value !== IscCostTypes.labor);
      } else if (x.costType.toLowerCase() === 'other' && new Date(x.expiryDate) < new Date(createdDate)) { // Update the data (Instead of travel it should be callOut from the API.)
        costTypes = costTypes.filter(x => x.value !== IscCostTypes.other);
      }
    });
    if (coverages.findIndex(x => x.costType.toLowerCase() === 'material') === -1) {
      costTypes = costTypes.filter(x => x.value !== IscCostTypes.material);
    }
    if (coverages.findIndex(x => x.costType.toLowerCase() === 'labor') === -1) {
      costTypes = costTypes.filter(x => x.value !== IscCostTypes.labor);
    }
    if (coverages.findIndex(x => x.costType.toLowerCase() === 'other') === -1) {
      costTypes = costTypes.filter(x => x.value !== IscCostTypes.other);
    }
    return costTypes;
  }

  updateCostTypeDataSource(args) {
    if (args.itemData.referenceActivityDescription === 'Warranty Service' && this.equipmentInfoData) {
      this.costTypeObject.dataSource = this.checkWarrantyContractCoverage(this.equipmentInfoData.warrantyDescriptionObj);
    } else if (args.itemData.referenceActivityDescription === 'Contract Service' && this.equipmentInfoData) {
      this.costTypeObject.dataSource = this.checkWarrantyContractCoverage(this.equipmentInfoData.serviceContractDescriptionObj);
    }
  }

  editAssignmentDetailReferenceActivity(): CellEdit {
    return {
      read: () => this.assignmentDetailReferenceActivityObject?.value,
      destroy: () => this.assignmentDetailReferenceActivityObject?.destroy(),
      open: args => {
        return this.assignmentDetailReferenceActivityObject = new TextEditor({
          value: args.rowData.referenceActivityCode,
          enabled: false
        });
      }
    }
  }

  editAssignmentDetailServiceType(): CellEdit {
    return {
      read: () => this.assignmentDetailServiceTypeObject?.value,
      destroy: () => this.assignmentDetailServiceTypeObject?.destroy(),
      open: args => {
        return this.assignmentDetailServiceTypeObject = new TextEditor({
          value: args.rowData.serviceTypeDescription,
          enabled: false
        });
      }
    }
  }

  editCostType(): CellEdit {
    return {
      read: () => this.costTypeObject?.value,
      destroy: () => this.costTypeObject?.destroy(),
      open: args => {
        return this.costTypeObject = new DropdownEditor({
          dataSource: this.costTypes,
          fields: { value: 'value', text: 'text' },
          value: args.rowData.costType,
          popupWidth: '150px',
          change: event => {
            this.setTransactionValuesOnCostTypeChange(event.value, args.rowData);
            this.iscDiscountAmountObject.enabled = this.isIscDiscountEnabled();
            this.iscPriceObject.enabled = this.isIscPriceEnabled();
            // if (event.value !== IscCostTypes.material) {
            //     delete this.assignmentDetailsGrid.getColumnByField('qty').validationRules['max'];
            // }
            this.setItemCodeValidation(event.value);

            this.tempUnit = this.getUnit(event.value);
          }
        });
      }
    }
  }

  setItemCodeValidation(costType) {
    this.assignmentDetailsGrid.getColumnByField('itemCode').validationRules['required'] = costType === IscCostTypes.material;
  }

  /** The Item column's Advanced Search button. */
  setAdvancedSearchVisible(visible: boolean) {
    this.itemCodeObject?.actionVisible.set(visible);
  }

  setCustomerPrice(price, rowData, sourceFxn?) {
    this.customerPriceValue = price;
    const isWarranty: boolean = this.assignmentObject?.itemData && this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode) === 'Warranty Service';
    const isContract: boolean = this.assignmentObject?.itemData && this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode) === 'Contract Service';
    if (this.customerPriceObject && !isWarranty && !isContract) {
      this.customerPriceObject.value = price;
    } else {
      this.customerPriceObject && (this.customerPriceObject.value = price);
      this.onCustomerPriceChange(price, rowData, sourceFxn);
    }
  }

  setDiscountAmountValue(discount) {
    this.discountAmountObject.value = discount;
  }

  onCustomerPriceChange(price, rowData, sourceFxn?) {
    const qty = this.quantityObject?.value;
    const customerPrice = +price?.toFixed(2);
    const iscPrice = this.iscPriceObject ? this.iscPriceObject.value : rowData.price;
    !price && this.setDiscountAmountValue(0);
    let discount = this.discountAmountObject?.value ?? rowData.discountAmount;
    if (!['Billable Service', 'Warranty Service', 'Contract Service'].includes(this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode))) {
      discount = customerPrice * qty;
      if (this.discountAmountObject) {
        this.discountAmountObject.value = customerPrice && qty ? customerPrice * qty : 0;
        this.discountAmountObject.max = customerPrice && qty ? customerPrice * qty : null;
      }
    } else {
      if (['Warranty Service', 'Contract Service'].includes(this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode))) {
        this.discountAmountObject.value = 0;
        discount = 0;
      }
    }
    const tax = rowData.taxpercent;
    const warranty = this.assignmentObject.value && this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode) === 'Warranty Service' && this.getWarrantyAmount() || 0;
    const contract = this.assignmentObject.value && this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode) === 'Contract Service' && this.getContractAmount() || 0;

    if (this.warrantyAmountObject) {
      this.warrantyAmountObject.value = warranty;
    }
    if (this.contractAmountObject) {
      this.contractAmountObject.value = contract;
    }
    this.calculateTotalAmount({ qty, customerPrice, iscPrice, discount, tax, warranty, contract }, rowData);
  }

  setTransactionValuesOnCostTypeChange(costType: string, rowData) {
    this.subcostTypeObject.enabled = costType === IscCostTypes.other;
    this.itemCodeObject.enabled = costType === IscCostTypes.material;
    this.subcostTypeObject.value = null;
    this.itemCodeObject.value = null;
    this.itemDescriptionObject.value = null;
    const isBillable = this.getRefActivityCategory(this.assignmentObject?.itemData?.referenceActivityCode) === 'Billable Service';
    if (costType === IscCostTypes.labor) {
      this.iscPriceObject.value = this.data?.isNationalAccount ? this.iscEmployeeDetails.t2LaborRate : (isBillable ? this.laborRate : this.iscEmployeeDetails.t1LaborRate);
      this.totalAmountObject.value = this.iscPriceObject.value;
      this.itemDescriptionObject.value = this.getItemDescription(costType);
      this.setCustomerPrice(this.laborRate, rowData, 'cost type labor');
      this.setAdvancedSearchVisible(false);
    } else if (costType === IscCostTypes.other) {
      this.discountAmountObject.value = 0;
      this.iscPriceObject.value = 0;
      this.totalAmountObject.value = 0;
      this.setCustomerPrice(0, rowData, 'cost type other');
      this.setAdvancedSearchVisible(false);
    } else if (costType === IscCostTypes.material) {
      this.discountAmountObject.value = 0;
      this.iscPriceObject.value = 0;
      this.totalAmountObject.value = 0;
      this.setCustomerPrice(0, rowData, 'cost type material');
      this.setAdvancedSearchVisible(true);
    } else {
      this.iscPriceObject.value = 0;
      this.iscDiscountAmountObject.value = 0;
      this.totalAmountObject.value = 0;
      this.discountAmountObject.value = 0;
      this.setCustomerPrice(0, rowData, 'no cost type selected');
      this.setAdvancedSearchVisible(false);
    }
    this.laborTypeObject && (this.laborTypeObject.value = this.getLaborType(costType));
    this.unitObject && (this.unitObject.value = this.getUnit(costType));
    this.costComponentObject && (this.costComponentObject.value = this.getCostComponent(costType));
    this.transactionWarehouseObject && (this.transactionWarehouseObject.value = this.getWarehouse(costType));
    this.taskObject && (this.taskObject.value = this.getTask(costType));
    this.quantityObject.value = 1;
    this.assignmentDetailStartTimeObject && (this.assignmentDetailStartTimeObject.value = this.assignmentDetailStartTimeValue);
    this.taxObject && (this.taxObject.value = 0);
    this.warrantyAmountObject && (this.warrantyAmountObject.value = 0);
    this.contractAmountObject && (this.contractAmountObject.value = 0);
    this.taxAmount = 0;
    this.taxPercentObject && (this.taxPercentObject.value = this.getTaxRate(costType));

    this.assignmentDetailsGrid.getColumnByField('comments').validationRules['required'] = false;
    this.commentsObject && (this.commentsObject.value = null);

    this.returnReasonObject && (this.returnReasonObject.enabled = costType === IscCostTypes.material);

    this.setQuantityFormatAndSteps(costType);
  }

  setQuantityFormatAndSteps(costType) {
    this.quantityObject.format = costType === IscCostTypes.material ? 'n' : 'n2';
    this.quantityObject.step = costType === IscCostTypes.material ? 1 : 0.1;
    this.quantityObject.decimals = costType === IscCostTypes.material ? 0 : 2;
  }

  editSubCostType(): CellEdit {
    return {
      read: () => this.subcostTypeObject?.value,
      destroy: () => this.subcostTypeObject?.destroy(),
      open: args => {
        return this.subcostTypeObject = new DropdownEditor({
          dataSource: IscSubCostTypeList,
          fields: { value: 'value', text: 'text' },
          value: args.rowData.subCostType || '',
          popupWidth: '150px',
          enabled: args.rowData.costType === IscCostTypes.other,
          change: event => {
            this.mileageObject.enabled = event.value === SubCostTypes.travelCalloutCharge;

            const isNumber = this.costTypeObject.value === CostTypes.material || event.value && event.value !== SubCostTypes.travelCalloutCharge ? true : false;
            this.quantityObject.format = isNumber ? 'n' : 'n2';
            this.quantityObject.step = isNumber ? 1 : 0.1;
            this.quantityObject.decimals = isNumber ? 0 : 2;

            if (event.value !== SubCostTypes.travelCalloutCharge)
              this.mileageObject.value = null;
            if (event.isInteracted)
              this.itemDescriptionObject.value = event.itemData?.text || null;

            const isTravelCallout_mileage = [SubCostTypes.travelCalloutCharge, SubCostTypes.mileage].includes(event.value);
            this.iscPriceObject.enabled = this.isIscPriceEnabled();
            this.quantityObject.enabled = this.costTypeObject.value === IscCostTypes.other ? event.value !== SubCostTypes.travelCalloutCharge : true;
            this.iscDiscountAmountObject.enabled = this.isIscDiscountEnabled();
            if (event.value && !isTravelCallout_mileage) {
              this.discountAmountObject.value = 0
              this.iscPriceObject.value = 0;
            }
            this.iscDiscountAmountObject.value = 0;
            this.assignmentDetailsGrid.getColumnByField('comments').validationRules['required'] = event.value && event.value !== SubCostTypes.travelCalloutCharge;
            this.assignmentDetailsGrid.getColumnByField('mileage').validationRules['required'] = event.value === SubCostTypes.travelCalloutCharge;
            // this.assignmentDetailsGrid.getColumnByField('addtMileageCharged').validationRules['required'] = event.value === SubCostTypes.travelCalloutCharge;
            this.subcostTypeWorkflow(event.value, args.rowData);
            this.data?.isNationalAccount && this.checkIscRulesForSubcost(event.value, args.rowData, event.isInteracted);
          }
        });
      }
    }
  }

  subcostTypeWorkflow(subcostType, rowData) {
    const isBillable = this.getRefActivityCategory(this.assignmentObject?.itemData?.referenceActivityCode) === 'Billable Service';

    switch (subcostType) {
      case SubCostTypes.travelCalloutCharge:
        this.quantityObject.value = 1;
        this.setCustomerPrice(this.calloutRate, rowData, 'subcost type: travel callout charge');
        const mileage = this.mileageObject?.value;
        let mileageExceededPrice = mileage > this.iscEmployeeDetails.mileageThreshold ? mileage * this.iscEmployeeDetails.mileageRate : undefined;
        this.iscPriceObject.value = this.data?.isNationalAccount ? mileageExceededPrice ?? this.iscEmployeeDetails.t2CalloutRate
          : isBillable ? this.calloutRate : (mileageExceededPrice ?? this.iscEmployeeDetails.t1CalloutRate);
        this.totalAmountObject.value = this.iscPriceObject.value * this.quantityObject.value;
        break;
      case SubCostTypes.mileage:
        this.setCustomerPrice(this.USER.mileageRate, rowData, 'subcost type: mileage');
        this.iscPriceObject.value = this.iscEmployeeDetails.mileageRate;
        this.totalAmountObject.value = this.iscPriceObject.value * this.quantityObject.value;
        break;
      case SubCostTypes.tax:
        this.quantityObject.value = 1;
        this.setCustomerPrice(this.getTotalTaxAmount(), rowData, 'subcost type: tax');
        this.totalAmountObject.value = this.getTotalTaxAmount();
        break;
      case null: break;
      default:
        this.quantityObject.value = 1;
        this.setCustomerPrice(0, rowData, 'subcost type: other than travel callout, mileage, tax');
        this.totalAmountObject.value = this.iscPriceObject.value * this.quantityObject.value;
        break;
    }
  }

  checkIscRulesForMileageItem(costType, rowData) {
    this.data?.isNationalAccount && costType === IscCostTypes.material && this.claimMileageItem();
    this.data?.isNationalAccount && costType === IscCostTypes.material && this.billMileageItem(rowData);
  }

  claimMileageItem() {
    !this.iscRulesForSO.addMileageItem && this.commonService.showNotification('warning', CANNOT_CLAIM_TRANSACTION_MESSAGE, 'center', 5000);
    !this.iscRulesForSO.addMileageItem && (this.totalAmountObject.value = 0);
  } // 

  billMileageItem(rowData) {
    const price = this.iscRulesForSO.billMileageItem ? this.iscPriceObject.value : 0;
    this.setCustomerPrice(price, rowData, 'isc rule for national account: bill mileage item');
  }

  checkIscRulesForSubcost(subcostType, rowData, subcostInteracted: boolean = false) {
    subcostType === SubCostTypes.travelCalloutCharge && this.claimMultipleTripCharge(rowData, subcostInteracted);
    subcostType === SubCostTypes.travelCalloutCharge && this.billMultipleTripCharge(rowData);
    subcostType === SubCostTypes.local && this.claimLocalParts(subcostInteracted);
    subcostType === SubCostTypes.local && this.billLocalParts(rowData);
    subcostType === SubCostTypes.mileage && this.claimAdditionalMileage(subcostInteracted);
    subcostType === SubCostTypes.mileage && this.billAdditionalMileage(rowData);
    subcostType === SubCostTypes.freight && this.claimFreightCharge(subcostInteracted);
    subcostType === SubCostTypes.freight && this.billFreightCharge(rowData);
    subcostType === SubCostTypes.tax && this.claimTax(subcostInteracted);
  }

  isAmountClaimable(rowData) {
    switch (this.subcostTypeObject.value) {
      case SubCostTypes.travelCalloutCharge:
        const travelCalloutChargeExists = (this.assignmentDetailsGrid?.dataSource as any)?.findIndex(x => x.rowId !== rowData.rowId && !x.isDeleted && x.subCostType === SubCostTypes.travelCalloutCharge);
        if (travelCalloutChargeExists > -1) {
          return this.iscRulesForSO?.claimMultipleTripCharge ?? true;
        } else {
          return true;
        }
      case SubCostTypes.local:
        return this.iscRulesForSO?.claimLocalPart ?? true;
      case SubCostTypes.mileage:
        return this.iscRulesForSO?.claimAddtMileage ?? true;
      case SubCostTypes.freight:
        return this.iscRulesForSO?.claimFrieght ?? true;
      case SubCostTypes.tax:
        return this.iscRulesForSO?.iscTax ?? true;
      default:
        return true;
    }
  }

  claimMultipleTripCharge(rowData, subcostInteracted) {
    const travelCalloutChargeExists = (this.assignmentDetailsGrid?.dataSource as any)?.findIndex((x, index) => x.rowId !== rowData.rowId && index < rowData.index && !x.isDeleted && x.subCostType === SubCostTypes.travelCalloutCharge);
    if (travelCalloutChargeExists > -1) {
      !this.iscRulesForSO.claimMultipleTripCharge && subcostInteracted && this.commonService.showNotification('warning', CANNOT_CLAIM_TRANSACTION_MESSAGE, 'center', 5000);
      !this.iscRulesForSO.claimMultipleTripCharge && subcostInteracted && (this.totalAmountObject.value = 0);
    }
  }

  billMultipleTripCharge(rowData) {
    const travelCalloutChargeExists = (this.assignmentDetailsGrid?.dataSource as any)?.findIndex((x, index) => x.rowId !== rowData.rowId && index < rowData.index && !x.isDeleted && x.subCostType === SubCostTypes.travelCalloutCharge);
    if (travelCalloutChargeExists > -1) {
      const price = this.iscRulesForSO.billMultipleTripCharge ? this.calloutRate : 0;
      this.setCustomerPrice(price, rowData, 'isc rule for national account: bill multiple trip charge');
    }
  }

  claimLocalParts(subcostInteracted) {
    !this.iscRulesForSO.claimLocalPart && subcostInteracted && this.commonService.showNotification('warning', CANNOT_CLAIM_TRANSACTION_MESSAGE, 'center', 5000);
    !this.iscRulesForSO.claimLocalPart && subcostInteracted && (this.totalAmountObject.value = 0);
  }

  billLocalParts(rowData) {
    const price = this.iscRulesForSO.billLocalPart ? this.iscPriceObject.value : 0;
    this.setCustomerPrice(price, rowData, 'isc rule for national account: bill local part');
  }

  claimAdditionalMileage(subcostInteracted) {
    !this.iscRulesForSO.claimAddtMileage && subcostInteracted && this.commonService.showNotification('warning', CANNOT_CLAIM_TRANSACTION_MESSAGE, 'center', 5000);
    !this.iscRulesForSO.claimAddtMileage && subcostInteracted && (this.totalAmountObject.value = 0);
  }

  billAdditionalMileage(rowData) {
    const price = this.iscRulesForSO.billAddtMileage ? this.iscPriceObject.value : 0;
    this.setCustomerPrice(price, rowData, 'isc rule for national account: bill additional mileage');
  }

  claimFreightCharge(subcostInteracted) {
    !this.iscRulesForSO.claimFrieght && subcostInteracted && this.commonService.showNotification('warning', CANNOT_CLAIM_TRANSACTION_MESSAGE, 'center', 5000);
    !this.iscRulesForSO.claimFrieght && subcostInteracted && (this.totalAmountObject.value = 0);
  }

  billFreightCharge(rowData) {
    const price = this.iscRulesForSO.billFrieght ? this.iscPriceObject.value : 0;
    this.setCustomerPrice(price, rowData, 'isc rule for national account: bill freight charge');
  }

  claimTax(subcostInteracted) {
    !this.iscRulesForSO.iscTax && subcostInteracted && this.commonService.showNotification('warning', CANNOT_CLAIM_TRANSACTION_MESSAGE, 'center', 5000);
    !this.iscRulesForSO.iscTax && subcostInteracted && (this.totalAmountObject.value = 0);
  }

  getTotalTaxAmount() {
    let tax = 0;
    (this.assignmentDetailsGrid?.dataSource as any)?.forEach(transaction => {
      if (!transaction.isDeleted)
        tax += transaction.taxAmount;
    });
    return +tax?.toFixed(2);
  }

  showItemPopup() {
    this.showItemAdvancedSearchPopup = true;
  }

  onItemAdvancedSearchPopupClose(data: any) {
    this.itemChangedFromAdvanceSearch = true;
    this.rowServiceItemGroup = data?.serviceItemGroup;
    if (this.assignmentDetailsGrid.isEdit) {
      this.serviceOrderService.popupLoader.next(true);
      if (data) {
        this.itemDescriptionObject.value = data?.itemDescription;
        this.itemCodeObject.dataSource = [{
          text: `${data?.item} | ${data?.itemDescription}`,
          value: data?.item,
          ...data
        }];
        this.itemCodeObject.value = data?.item;
        this.itemStatus = data.itemStatus;
        this.alternateItem = data.alternateItem;
      }
      setTimeout(() => {
        this.showItemAdvancedSearchPopup = false;
        this.serviceOrderService.popupLoader.next(false);
      }, 400);
    } else {
      const rowIndex = this.assignmentDetailsGrid.getRowIndexByPrimaryKey(this.selectedRowId);
      this.serviceOrderService.popupLoader.next(true);
      this.showItemAdvancedSearchPopup = false;
      setTimeout(() => {
        this.assignmentDetailsGrid.selectRow(rowIndex);
        this.skipBeginEditEvent = true;
        this.assignmentDetailsGrid.startEdit();
        if (data) {
          setTimeout(() => {
            this.serviceOrderService.popupLoader.next(false);
            this.itemDescriptionObject.value = data?.itemDescription;
            this.itemCodeObject.dataSource = [{
              text: `${data?.item} | ${data?.itemDescription}`,
              value: data?.item,
              ...data
            }];
            this.itemCodeObject.value = data?.item;
          }, 400);
        } else {
          this.serviceOrderService.popupLoader.next(false);
        }
      }, 2000);
    }
  }

  editItem(): CellEdit {
    return {
      read: () => this.itemCodeObject?.value,
      destroy: () => this.itemCodeObject?.destroy(),
      open: args => {
        this.selectedRowId = args.rowData?.rowId;
        // The Advanced Search button starts hidden; the cost type shows it (setTransactionValuesOnCostTypeChange, beginEdit).
        return this.itemCodeObject = new DropdownEditor({
          dataSource: this.itemsList,
          fields: { value: 'value', text: 'text' },
          value: args.rowData.itemCode,
          allowFiltering: true,
          showClearButton: true,
          popupWidth: '350px',
          openOnFocus: true,
          enabled: this.costTypeObject.value === IscCostTypes.material,
          filtering: args => { this.onItemUpdate.next(args.text) },
          action: { title: 'Advanced Search', iconClass: 'fas fa-info', click: () => this.showItemPopup() },
          change: event => {
            if (!event.value) {
              this.itemStatus = '';
              this.alternateItem = '';
              return;
            }
            this.getPriceForItem = event.isInteracted || this.itemChangedFromAdvanceSearch;
            const unit = this.tempUnit;
            if (event.itemData?.value !== 'LOCAL' && this.getPriceForItem) {
              this.getItemPrice(event.itemData?.value, unit, args.rowData, this.quantityObject.value);
            }
            if (event.value === 'Mileage') {
              this.checkIscRulesForMileageItem(event.value, args.rowData);
            }
            this.itemDescriptionObject.value = event.itemData?.itemDescription || null;
            this.serviceItemGroup = event.itemData?.serviceItemGroup;
            this.rowServiceItemGroup = event.itemData?.serviceItemGroup;
            this.itemGroup = event.itemData?.itemGroup;
            this.itemChangedFromAdvanceSearch = false;
            this.itemStatus = event.itemData.status;
            this.alternateItem = event.itemData.alternateItem;
          }
        });
      }
    }
  }

  getItemPrice(itemCode, unit, rowData, quantity = 1) {
    const data = {
      company: this.USER.company,
      item: itemCode,
      unit: unit,
      quantity,
      configuration: this.data.customerCode
    };
    const iscData = {
      ...data,
      configuration: this.USER.iscCode
    }
    if (data.item && data.quantity) {
      this.showLoader = true;
      forkJoin([
        this.serviceOrderService.getPrice(data),
        this.serviceOrderService.getPrice(iscData),
      ]).subscribe((res: any) => {
        if (res[0] && res[0].isSuccessful && res[0].result) {
          const price = res[0].result.bookPrice ? +res[0].result.bookPrice.bookPriceValue?.toFixed(2) : 0;
          this.discountAmountObject.value = res[0].result?.discountAmount ? +res[0].result.discountAmount.discountAmountValue?.toFixed(2) : 0;
          this.setCustomerPrice(price, rowData, 'on item changed');
        } else {
          this.commonService.showDialogueWithNoTimer('error', "RIMS failed to get the price of this item. \n Please Contact Support or Enter the price of the item manually.");
        }
        if (res[1] && res[1].isSuccessful && res[1].result) {
          const price = res[1].result.bookPrice ? +res[1].result.bookPrice.bookPriceValue?.toFixed(2) : 0;
          this.iscPriceObject.value = price;
          const isBillable = this.getRefActivityCategory(this.assignmentObject?.itemData?.referenceActivityCode) === 'Billable Service';
          const iscNaDiscountAmount = this.costTypeObject.value === CostTypes.material && this.data.isNationalAccount && isBillable ? price * this.quantityObject.value * this.iscNaDiscountRate : 0;
          this.iscDiscountAmountObject.value = res[1].result?.discountAmount ? +res[1].result.discountAmount.discountAmountValue?.toFixed(2) - iscNaDiscountAmount : 0;
          this.totalAmountObject.value = this.isAmountClaimable(rowData) ? price * this.quantityObject.value - this.iscDiscountAmountObject.value : 0;
        } else {
          this.commonService.showDialogueWithNoTimer('error', "RIMS failed to get the price of this item. \n Please Contact Support or Enter the price of the item manually.");
        }
        this.showLoader = false;
      }, (error: HttpErrorResponse) => {
        this.discountAmountObject.value = 0;
        this.iscPriceObject.value = 0;
        this.setCustomerPrice(0, rowData, 'item change API fail');
        this.commonService.showDialogueWithNoTimer('error', "RIMS failed to get the price of this item. \n Please Contact Support or Enter the price of the item manually.");
        this.showLoader = false;
      });
    }
  }

  setCustomerTotalAmountValue(totalAmount) {
    this.customerTotalAmountObject && (this.customerTotalAmountObject.value = totalAmount);
    this.customerTotalAmountValue = totalAmount;
  }

  updateItemOnHandQuantity(itemCode, onHandQty, rowData) {
    let calculatedOnHand = onHandQty;
    this.loadedAssignmentItemDetails.forEach(x => {
      if (itemCode === x.itemCode) {
        calculatedOnHand += x.issuedQty;
      }
    });
    (this.assignmentDetailsGrid.dataSource as any).forEach(x => {
      if (itemCode === x.itemCode && !x.isDeleted) {
        if (!this.assignmentDetailsGrid.isEdit || rowData.rowId != x.rowId)
          calculatedOnHand -= x.qty;
      }
    });
    return calculatedOnHand;
  }

  editItemDescription(): CellEdit {
    return {
      read: () => this.itemDescriptionObject?.value,
      destroy: () => {
        this.itemDescriptionObject?.destroy();
        this.itemDescriptionObject = null;
      },
      open: args => {
        return this.itemDescriptionObject = new TextEditor({
          value: args.rowData.itemDescription,
          enabled: false
        });
      }
    }
  }

  editComments(): CellEdit {
    return {
      read: () => this.commentsObject?.value,
      destroy: () => this.commentsObject?.destroy(),
      open: args => {
        return this.commentsObject = new TextEditor({
          value: args.rowData.comments,
        });
      }
    }
  }

  editMileage(): CellEdit {
    return {
      read: () => this.mileageObject?.value,
      destroy: () => this.mileageObject?.destroy(),
      open: args => {
        return this.mileageObject = new NumberEditor({
          value: args.rowData.mileage,
          format: 'n2',
          min: 0,
          decimals: 2,
          enabled: args.rowData.subCostType && args.rowData.subCostType === SubCostTypes.travelCalloutCharge,
          // The estimated distance of the order (the old focus tooltip).
          hint: () => 'Estimated Distance: ' + ((this.serviceOrderService.estimatedMiles || this.data.estimatedMiles) ?? 'Not data found!'),
          change: (event) => {
            const isBillable = this.getRefActivityCategory(this.assignmentObject?.itemData?.referenceActivityCode) === 'Billable Service';
            if (event.value != null) {
              if (isBillable && !this.data.isNationalAccount) { // regular account and billable service
                this.onMileageChangeForBillableAndRegular(args);
              } else {
                this.calculateTotalForMileage(event.value, args.rowData);
              }
            }
          }
        });
      }
    }
  }

  // editAdditionalMileageCharge() {
  //     return {
  //         create: () => {
  //             this.additionalMileage = document.createElement('input');
  //             return this.additionalMileage;
  //         },
  //         read: () => {
  //             if (this.additionalMileageObject) {
  //                 return this.additionalMileageObject.value;
  //             }
  //         },
  //         destroy: () => {
  //             if ( this.additionalMileageObject)
  //                 this.additionalMileageObject?.destroy();
  //         },
  //         write: (args) => {
  //             this.additionalMileageObject = new NumericTextBox({
  //                 value: args.rowData.addtMileageCharged ?? 0,
  //                 showSpinButton: false,
  //                 format: 'n2',
  //                 min: 0,
  //                 decimals: 2,
  //                 enabled: false,
  //             });
  //             this.additionalMileageObject.appendTo(this.additionalMileage);
  //         }
  //     }
  // }

  calculateTotalForMileage(mileage, rowData) {
    // const additionalMileage = mileage > this.iscEmployeeDetails.mileageThreshold ?  mileage - this.iscEmployeeDetails.mileageThreshold: 0;
    // this.additionalMileageObject.value = additionalMileage * this.iscEmployeeDetails.mileageRate;
    const isBillable = this.getRefActivityCategory(this.assignmentObject?.itemData?.referenceActivityCode) === 'Billable Service';
    if (mileage) {
      let mileageExceededPrice = mileage > this.iscEmployeeDetails.mileageThreshold ? mileage * this.iscEmployeeDetails.mileageRate : undefined;
      this.iscPriceObject.value = this.data?.isNationalAccount ? mileageExceededPrice ?? this.iscEmployeeDetails.t2CalloutRate
        : isBillable ? this.calloutRate : (mileageExceededPrice ?? this.iscEmployeeDetails.t1CalloutRate);

      this.totalAmountObject.value = this.isAmountClaimable(rowData) ? this.quantityObject.value * this.iscPriceObject.value - this.iscDiscountAmountObject.value : 0;
      this.data?.isNationalAccount && this.checkIscRulesForSubcost(this.subcostTypeObject.value, rowData);
    }
  }

  editQuantity(): CellEdit {
    return {
      read: () => this.quantityObject?.value,
      destroy: () => {
        this.onHandQuantity = undefined;
        this.quantityObject?.destroy();
      },
      open: args => {
        const isNumber = this.costTypeObject.value === CostTypes.material || this.subcostTypeObject.value && this.subcostTypeObject.value !== SubCostTypes.travelCalloutCharge ? true : false;
        return this.quantityObject = new NumberEditor({
          value: args.rowData.qty,
          format: isNumber ? 'n' : 'n2',
          min: 0,
          step: isNumber ? 1 : 0.1,
          decimals: isNumber ? 0 : 2,
          enabled: this.costTypeObject.value === IscCostTypes.other ? this.subcostTypeObject.value !== SubCostTypes.travelCalloutCharge : true,
          // Typing is applied after a 200 ms pause, as the old keyup handler did (each change asks for the price).
          typingDelay: 200,
          // The On Hand count, for a Material row once it is known (the old focus tooltip).
          hint: () => this.costTypeObject?.value === IscCostTypes.material && this.onHandQuantity !== undefined ? 'On Hand: ' + this.onHandQuantity : null,
          change: event => {
            const qty = +event.value?.toFixed(2) || 0;
            const costType = this.costTypeObject.value;

            if (costType === IscCostTypes.material && this.itemCodeObject.value && qty) {
              this.tempUnit = this.getUnit(costType);
              const data = {
                company: this.USER.company,
                item: this.itemCodeObject.value,
                unit: this.tempUnit,
                quantity: qty,
                configuration: this.data.customerCode
              };
              const iscData = {
                ...data,
                configuration: this.USER.iscCode
              }
              this.showLoader = true;
              forkJoin([
                this.serviceOrderService.getPrice(data),
                this.serviceOrderService.getPrice(iscData),
              ]).subscribe((res: any) => {
                if (res[0] && res[0].isSuccessful && res[0].result) {
                  const price = res[0].result.bookPrice ? +res[0].result.bookPrice.bookPriceValue?.toFixed(2) : 0;
                  this.discountAmountObject.value = res[0].result?.discountAmount ? +res[0].result.discountAmount.discountAmountValue?.toFixed(2) : 0;
                  this.setCustomerPrice(price, args.rowData, 'on quantity change for item API success');
                  this.onQuantityChange(args, qty);
                } else {
                  this.commonService.showNotification('error', "Error fetching price from Pricebook. Please contact support.");
                }
                if (res[1] && res[1].isSuccessful && res[1].result) {
                  const price = res[1].result.bookPrice ? +res[1].result.bookPrice.bookPriceValue?.toFixed(2) : 0;
                  this.iscPriceObject.value = price;
                  const isBillable = this.getRefActivityCategory(this.assignmentObject?.itemData?.referenceActivityCode) === 'Billable Service';

                  const iscNaDiscountAmount = this.costTypeObject.value === CostTypes.material && this.data.isNationalAccount && isBillable ? price * this.quantityObject.value * this.iscNaDiscountRate : 0;
                  this.iscDiscountAmountObject.value = res[1].result?.discountAmount ? +res[1].result.discountAmount.discountAmountValue?.toFixed(2) - iscNaDiscountAmount : 0;
                  this.totalAmountObject.value = this.isAmountClaimable(args.rowData) ? price * qty - this.iscDiscountAmountObject.value : 0;
                } else {
                  this.commonService.showNotification('error', "Error fetching price from Pricebook. Please contact support.");
                }
                this.showLoader = false;
              }, (error: HttpErrorResponse) => {
                this.setCustomerPrice(0, args.rowData, 'on quantity change for item API fail');
                this.discountAmountObject.value = 0;
                this.iscPriceObject.value = 0;
                this.commonService.showNotification('error', "Error fetching price from Pricebook. Please contact support.");
                this.showLoader = false;
              });
            } else {
              const isBillable = this.getRefActivityCategory(this.assignmentObject?.itemData?.referenceActivityCode) === 'Billable Service';
              this.onQuantityChange(args, qty);
              const regularAccount = !this.data.isNationalAccount;
              if (!(isBillable && regularAccount)) { // non-billable || national account
                const mileage = this.mileageObject.value;
                this.calculateTotalForMileage(mileage, args.rowData);
              }
            }
            this.subcostTypeObject?.value && this.data?.isNationalAccount && this.checkIscRulesForSubcost(this.subcostTypeObject.value, args.rowData);
          }
        });
      }
    }
  }

  onMileageChangeForBillableAndRegular(args) { // For time complexity I am just copying the code for this, it should be a common function for multiple things
    const qty = this.quantityObject?.value;
    const customerPrice = this.customerPriceObject ? +this.customerPriceObject.value.toFixed(2) : +this.customerPriceValue?.toFixed(2);
    const iscPrice = this.iscPriceObject ? this.iscPriceObject.value : args.rowData.price;
    let discount = this.discountAmountObject ? +this.discountAmountObject.value?.toFixed(2) : +args.rowData.discountAmount.toFixed(2);
    if (!['Billable Service', 'Warranty Service', 'Contract Service'].includes(this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode))) {
      discount = customerPrice * qty;
      if (this.discountAmountObject) {
        this.discountAmountObject.value = customerPrice && qty ? customerPrice * qty : 0;
        this.discountAmountObject.max = customerPrice && qty ? customerPrice * qty : null;
      }
    } else {
      if (['Warranty Service', 'Contract Service'].includes(this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode))) {
        this.discountAmountObject.value = 0;
        discount = 0;
      }
    }
    const tax = +args.rowData.taxpercent?.toFixed(2);
    const warranty = this.assignmentObject.value && this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode) === 'Warranty Service' && this.getWarrantyAmount() || 0;
    const contract = this.assignmentObject.value && this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode) === 'Contract Service' && this.getContractAmount() || 0;

    if (this.warrantyAmountObject) {
      this.warrantyAmountObject.value = warranty;
    }
    if (this.contractAmountObject) {
      this.contractAmountObject.value = contract;
    }
    this.calculateTotalAmount({ qty, customerPrice, iscPrice, discount, tax, warranty, contract }, args.rowData);
  }

  onQuantityChange(args, qty: number = 0) {
    const customerPrice = this.customerPriceObject ? +this.customerPriceObject.value.toFixed(2) : +this.customerPriceValue?.toFixed(2);
    const iscPrice = this.iscPriceObject ? this.iscPriceObject.value : args.rowData.price;
    let discount = this.discountAmountObject ? +this.discountAmountObject.value?.toFixed(2) : +args.rowData.discountAmount.toFixed(2);
    if (!['Billable Service', 'Warranty Service', 'Contract Service'].includes(this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode))) {
      discount = customerPrice * qty;
      if (this.discountAmountObject) {
        this.discountAmountObject.value = customerPrice && qty ? customerPrice * qty : 0;
        this.discountAmountObject.max = customerPrice && qty ? customerPrice * qty : null;
      }
    } else {
      if (['Warranty Service', 'Contract Service'].includes(this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode))) {
        this.discountAmountObject.value = 0;
        discount = 0;
      }
    }
    const tax = +args.rowData.taxpercent?.toFixed(2);
    const warranty = this.assignmentObject.value && this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode) === 'Warranty Service' && this.getWarrantyAmount() || 0;
    const contract = this.assignmentObject.value && this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode) === 'Contract Service' && this.getContractAmount() || 0;

    if (this.warrantyAmountObject) {
      this.warrantyAmountObject.value = warranty;
    }
    if (this.contractAmountObject) {
      this.contractAmountObject.value = contract;
    }
    this.calculateTotalAmount({ qty, customerPrice, iscPrice, discount, tax, warranty, contract }, args.rowData);
  }

  getRefActivityCategory(refActivityCode) {
    const refActivity = this.referenceActivities.find(act => act.value === refActivityCode);
    return refActivity ? refActivity.category : '';
  }

  editCustomerPrice(): CellEdit {
    return {
      read: () => this.customerPriceObject?.value,
      destroy: () => this.customerPriceObject?.destroy(),
      open: args => {
        return this.customerPriceObject = new NumberEditor({
          value: args.rowData.customerPrice,
          format: 'n2',
          min: 0,
          decimals: 2,
          enabled: false,
          change: (event) => {
            this.onCustomerPriceChange(event.value, args.rowData, 'customer price change');
          }
        });
      }
    }
  }

  editPrice(): CellEdit {
    return {
      read: () => this.iscPriceObject?.value,
      destroy: () => this.iscPriceObject?.destroy(),
      open: args => {
        // Typing reaches `change` as the user's (isInteracted), as the old keyup handler's keyPressed did.
        let keyPressed = false;
        return this.iscPriceObject = new NumberEditor({
          value: args.rowData.price,
          format: 'n2',
          min: this.quantityObject?.value ? this.iscDiscountAmountObject?.value / this.quantityObject.value || null : null, // Price Field: If (Price * Qty) < Discount Then Show error message - Cannot be less than discount
          decimals: 2,
          enabled: this.isIscPriceEnabled(),
          focus: () => {
            this.iscPriceObject.min = this.quantityObject?.value ? this.iscDiscountAmountObject.value / this.quantityObject.value || null : null;
          },
          change: (event) => {
            if (event.value != null) {
              if (keyPressed || event.isInteracted) {
                this.totalAmountObject.value = this.isAmountClaimable(args.rowData) ? event.value * this.quantityObject.value - this.iscDiscountAmountObject.value : 0;
                this.setCustomerPrice(event.value, args.rowData, 'on isc price change');
                keyPressed = false;
              }
              this.iscDiscountAmountObject.max = event.value * this.quantityObject?.value;
              this.subcostTypeObject?.value && this.data?.isNationalAccount && this.checkIscRulesForSubcost(this.subcostTypeObject.value, args.rowData);
            } else {
              this.iscPriceObject.value = 0;
            }
          }
        });
      }
    }
  }

  isIscPriceEnabled() {
    const isBillable = this.getRefActivityCategory(this.assignmentObject?.itemData?.referenceActivityCode) === 'Billable Service';
    if (!this.data.isNationalAccount && isBillable) { return true } else {
      return this.subcostTypeObject?.value && ![SubCostTypes.travelCalloutCharge, SubCostTypes.mileage].includes(this.subcostTypeObject.value);
    }
  }

  calculateTotalAmount(data, rowData?) {
    this.customerTotalAmountValue = +(data.qty && (data.customerPrice * data.qty) - (data.discount || 0) - (data.warranty || 0) - (data.contract || 0))?.toFixed(2);
    this.taxAmount = +(this.customerTotalAmountValue * data.tax / 100)?.toFixed(2);
    this.setCustomerTotalAmountValue(this.customerTotalAmountValue);
    const isBillable = this.getRefActivityCategory(this.assignmentObject?.itemData?.referenceActivityCode) === 'Billable Service';
    const regularAccount = !this.data.isNationalAccount;
    if (isBillable && regularAccount)
      this.totalAmountObject.value = +(data.iscPrice * data.qty - this.iscDiscountAmountObject.value).toFixed(2);
    else // non-billable || national-account; // also handles iscNaDiscountAmount login for materials
      this.totalAmountObject.value = this.isAmountClaimable(rowData) ? this.iscPriceObject.value * this.quantityObject.value - this.iscDiscountAmountObject.value : 0;

  }

  isIscDiscountEnabled() {
    const isBillable = this.getRefActivityCategory(this.assignmentObject?.itemData?.referenceActivityCode) === 'Billable Service';
    if (isBillable && !this.data.isNationalAccount) {
      return true;
    } else {
      const isCostTypeOther = this.costTypeObject?.value === IscCostTypes.other;
      const isTravelCallout_mileage = [SubCostTypes.travelCalloutCharge, SubCostTypes.mileage].includes(this.subcostTypeObject.value);
      return isCostTypeOther && this.subcostTypeObject?.value && !isTravelCallout_mileage;
    }
  }

  editIscDiscountAmount(): CellEdit {
    return {
      read: () => this.iscDiscountAmountObject?.value,
      destroy: () => this.iscDiscountAmountObject?.destroy(),
      open: args => {
        return this.iscDiscountAmountObject = new NumberEditor({
          value: args.rowData.iscDiscountAmount ?? 0,
          format: 'n2',
          min: null,
          decimals: 2,
          max: this.iscPriceObject?.value * this.quantityObject?.value || null,
          enabled: this.isIscDiscountEnabled(),
          focus: () => {
            const price = this.iscPriceObject?.value,
              qty = this.quantityObject?.value;
            this.iscDiscountAmountObject.max = price * qty;
          },
          change: (event) => {
            if (event.value != null) {
              if (this.mileageObject.value) {
                this.calculateTotalForMileage(this.mileageObject.value, args.rowData);
              } else {
                this.totalAmountObject.value = this.isAmountClaimable(args.rowData) ? this.quantityObject.value * this.iscPriceObject.value - this.iscDiscountAmountObject.value : 0;
                this.data?.isNationalAccount && this.checkIscRulesForSubcost(this.subcostTypeObject.value, args.rowData);
              }
              this.iscPriceObject.min = this.quantityObject?.value && event.value ? event.value / this.quantityObject.value || null : null;
            } else {
              this.iscDiscountAmountObject.value = 0;
            }
          }
        });
      }
    }
  }

  editDiscountAmount(): CellEdit {
    return {
      read: () => this.discountAmountObject?.value,
      destroy: () => this.discountAmountObject?.destroy(),
      open: args => {
        return this.discountAmountObject = new NumberEditor({
          value: args.rowData.discountAmount ?? 0,
          format: 'n2',
          min: 0,
          decimals: 2,
          max: this.customerPriceValue && this.quantityObject?.value && this.customerPriceValue * this.quantityObject.value || null,
          enabled: this.getRefActivityCategory(this.assignmentObject?.itemData?.referenceActivityCode) === 'Billable Service' || args.rowData.serviceItemGroup === '250SVC',
          focus: () => {
            const price = this.customerPriceObject?.value ?? this.customerPriceValue,
              qty = this.quantityObject && this.quantityObject.value;
            this.discountAmountObject.max = price && qty ? price * qty : null;
          },
          change: (event) => {
            this.discountValue = +event.value?.toFixed(2);
            const qty = this.quantityObject ? this.quantityObject.value : args.rowData.qty;
            const customerPrice = this.customerPriceObject ? +this.customerPriceObject.value.toFixed(2) : +this.customerPriceValue.toFixed(2);
            const iscPrice = this.iscPriceObject ? this.iscPriceObject.value : args.rowData.price;
            let discount = +event.value?.toFixed(2);
            if (!['Billable Service', 'Warranty Service', 'Contract Service'].includes(this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode))) {
              discount = customerPrice * qty;
              if (this.discountAmountObject) {
                this.discountAmountObject.value = customerPrice && qty ? customerPrice * qty : 0;
                this.discountAmountObject.max = customerPrice && qty ? customerPrice * qty : null;
              }
            } else {
              if (['Warranty Service', 'Contract Service'].includes(this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode))) {
                this.discountAmountObject.value = 0;
                discount = 0;
              }
            }
            const tax = args.rowData.taxpercent;

            const warranty = this.assignmentObject.value && this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode) === 'Warranty Service' && this.getWarrantyAmount() || 0;
            const contract = this.assignmentObject.value && this.getRefActivityCategory(this.assignmentObject.itemData.referenceActivityCode) === 'Contract Service' && this.getContractAmount() || 0;

            if (this.warrantyAmountObject) {
              this.warrantyAmountObject.value = warranty;
            }
            if (this.contractAmountObject) {
              this.contractAmountObject.value = contract;
            }
            this.calculateTotalAmount({ qty, customerPrice, iscPrice, discount, tax, warranty, contract }, args.rowData);
          }
        });
      }
    }
  }

  editContractAmount(): CellEdit {
    return {
      read: () => this.contractAmountObject?.value,
      destroy: () => this.contractAmountObject?.destroy(),
      open: args => {
        return this.contractAmountObject = new NumberEditor({
          value: args.rowData.contractCoverage ?? 0,
          min: 0,
          enabled: false,
        });
      }
    }
  }

  editWarrantyAmount(): CellEdit {
    return {
      read: () => this.warrantyAmountObject?.value,
      destroy: () => this.warrantyAmountObject?.destroy(),
      open: args => {
        return this.warrantyAmountObject = new NumberEditor({
          value: args.rowData.warrantyCoverage ?? 0,
          min: 0,
          enabled: false,
        });
      }
    }
  }

  editCustomerTotalAmount(): CellEdit {
    return {
      read: () => this.customerTotalAmountObject?.value,
      destroy: () => this.customerTotalAmountObject?.destroy(),
      open: args => {
        return this.customerTotalAmountObject = new NumberEditor({
          value: args.rowData.customerTotalAmount,
          enabled: false,
          min: 0,
          change: (event) => {
            this.taxAmount = +(this.customerTotalAmountObject.value * this.getTaxRate(this.costTypeObject.value) / 100)?.toFixed(2);
            if (this.taxObject) {
              this.taxObject.value = this.taxAmount;
            }
          }
        });
      }
    }
  }

  editTotalAmount(): CellEdit {
    return {
      read: () => this.totalAmountObject?.value,
      destroy: () => this.totalAmountObject?.destroy(),
      open: args => {
        return this.totalAmountObject = new NumberEditor({
          value: args.rowData.totalAmount,
          enabled: false,
          min: 0,
        });
      }
    }
  }

  editUnit(): CellEdit {
    return {
      read: () => this.unitObject?.value,
      destroy: () => this.unitObject?.destroy(),
      open: args => {
        return this.unitObject = new DropdownEditor({
          dataSource: this.units,
          fields: { value: 'value', text: 'text' },
          value: args.rowData.unit,
          allowFiltering: true,
          enabled: false
        });
      }
    }
  }

  editReturnReason(): CellEdit {
    return {
      read: () => this.returnReasonObject?.value,
      destroy: () => this.returnReasonObject?.destroy(),
      open: args => {
        return this.returnReasonObject = new DropdownEditor({
          dataSource: this.returnReasons,
          fields: { value: 'value', text: 'text' },
          popupWidth: '250px',
          enabled: this.costTypeObject.value === IscCostTypes.material,
          value: args.rowData.returnReasonCode
        });
      }
    }
  }

  editStartTime(): CellEdit {
    return {
      read: () => this.assignmentDetailStartTimeObject?.value,
      destroy: () => this.assignmentDetailStartTimeObject?.destroy(),
      open: args => {
        return this.assignmentDetailStartTimeObject = new DateTimeEditor({
          placeholder: "Select start date time...",
          value: args.rowData.startDate,
          min: args.rowData.startDate ? args.rowData.startDate : this.checkinTime,
          openOnFocus: true,
          allowEdit: false,
          change: ev => {
            this.assignmentDetailStartTimeValue = ev.value;
            if (this.assignmentDetailEndTimeObject) {
              this.assignmentDetailEndTimeObject.min = ev.value;
            }
          }
        });
      }
    }
  }

  editEndTime(): CellEdit {
    return {
      read: () => this.assignmentDetailEndTimeObject?.value,
      destroy: () => this.assignmentDetailEndTimeObject?.destroy(),
      open: args => {
        return this.assignmentDetailEndTimeObject = new DateTimeEditor({
          placeholder: "Select end date time...",
          value: args.rowData.endDate,
          min: args.rowData.startDate || new Date(),
          openOnFocus: true,
          allowEdit: false,
          change: ev => {
            if (this.assignmentDetailStartTimeObject) {
              this.assignmentDetailStartTimeObject.max = ev.value;
            }
          }
        });
      }
    }
  }

  editTask(): CellEdit {
    return {
      read: () => this.taskObject?.value,
      destroy: () => this.taskObject?.destroy(),
      open: args => {
        return this.taskObject = new TextEditor({
          value: args.rowData.task,
          enabled: false
        });
      }
    }
  }

  editTax(): CellEdit {
    return {
      read: () => this.taxObject?.value,
      destroy: () => this.taxObject?.destroy(),
      open: args => {
        return this.taxObject = new NumberEditor({
          value: args.rowData.taxAmount,
          enabled: false,
          change: args => {
          }
        });
      }
    }
  }

  editTaxPercent(): CellEdit {
    return {
      read: () => this.taxPercentObject?.value,
      destroy: () => this.taxPercentObject?.destroy(),
      open: args => {
        return this.taxPercentObject = new NumberEditor({
          value: args.rowData.taxpercent,
          enabled: false,
          change: args => {
          }
        });
      }
    }
  }

  editCostComponent(): CellEdit {
    return {
      read: () => this.costComponentObject?.value,
      destroy: () => this.costComponentObject?.destroy(),
      open: args => {
        return this.costComponentObject = new TextEditor({
          value: args.rowData.costComponent,
          enabled: false
        });
      }
    }
  }

  editTransactionWarehouse(): CellEdit {
    return {
      read: () => this.transactionWarehouseObject?.value,
      destroy: () => this.transactionWarehouseObject?.destroy(),
      open: args => {
        return this.transactionWarehouseObject = new TextEditor({
          value: args.rowData.warehouse,
          enabled: false
        });
      }
    }
  }

  editLaborType(): CellEdit {
    return {
      read: () => this.laborTypeObject?.value,
      destroy: () => this.laborTypeObject?.destroy(),
      open: args => {
        return this.laborTypeObject = new TextEditor({
          value: args.rowData.laborType,
          enabled: false
        });
      }
    }
  }

  ngOnDestroy() {
    this.loadedAssignmentItemDetails = null;
    this?.destroy$.next(null);
    this?.destroy$.unsubscribe();
  }
}
